// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8Y2lyY2xlIGN4PSIxMCIgY3k9IjEwIiByPSIxMCIgZmlsbD0iI0MxRDhGRiIvPgogIDxwYXRoIGZpbGw9IiM0QTdERkQiIGQ9Im0xMS4wNiA0LjY1IDUgNWEuNDguNDggMCAwIDEgMCAuN2wtNSA1YS40OTguNDk4IDAgMCAxLS43MSAwbC0uNy0uN2EuNS41IDAgMCAxIDAtLjcxTDEyLjU5IDExSDQuNWEuNS41IDAgMCAxLS41LS41di0xYS41LjUgMCAwIDEgLjUtLjVoOC4wOUw5LjY1IDYuMDZhLjUuNSAwIDAgMSAwLS43MWwuNy0uN2EuNS41IDAgMCAxIC43MSAwWiIvPgo8L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/jpeg;base64,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", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rc__3w3c2z {
  overflow: hidden;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  height: var(--rc-topline-header-height);
}

.rc__5h5udh {
  font-size: 0;
  -webkit-text-decoration: none;
  text-decoration: none;
}

.rc__3mbvr2 {
  max-height: var(--rc-topline-header-height);
}

.rc__7t272a {
  display: flex;
  -moz-column-gap: 2px;
       column-gap: 2px;
  margin-right: 40px;
  flex-shrink: 0;
  flex-direction: row;
  align-items: center;
}

@media (max-width: 1299px) {
      .rc__7t272a.rc__5spb97 {
        flex-direction: column;
        align-items: flex-start;
      }

        .rc__7t272a.rc__5spb97 .rc__8k27m3 {
          width: 135px;
          height: 30px;
          background-image: var(--rc-topline-logo-rambler-small-bgImage);
        }

        .rc__7t272a.rc__5spb97 .rc__36gd3d {
          height: 30px;
          background-position: 0 0.5px;
        }
      .rc__7t272a.rc__2ycc71 {
        flex-direction: column;
        align-items: flex-start;
      }

        .rc__7t272a.rc__2ycc71 .rc__8k27m3 {
          width: 135px;
          height: 30px;
          background-image: var(--rc-topline-logo-rambler-small-bgImage);
        }

        .rc__7t272a.rc__2ycc71 .rc__36gd3d {
          height: 30px;
          background-position: 0 0.5px;
        }
      .rc__7t272a.rc__7d1wxy {
        flex-direction: column;
        align-items: flex-start;
      }

        .rc__7t272a.rc__7d1wxy .rc__8k27m3 {
          width: 135px;
          height: 30px;
          background-image: var(--rc-topline-logo-rambler-small-bgImage);
        }

        .rc__7t272a.rc__7d1wxy .rc__36gd3d {
          height: 30px;
          background-position: 0 0.5px;
        }
      .rc__7t272a.rc__5xnt8h {
        flex-direction: column;
        align-items: flex-start;
      }

        .rc__7t272a.rc__5xnt8h .rc__8k27m3 {
          width: 135px;
          height: 30px;
          background-image: var(--rc-topline-logo-rambler-small-bgImage);
        }

        .rc__7t272a.rc__5xnt8h .rc__36gd3d {
          height: 30px;
          background-position: 0 0.5px;
        }
      .rc__7t272a.rc__2p7qpq {
        flex-direction: column;
        align-items: flex-start;
      }

        .rc__7t272a.rc__2p7qpq .rc__8k27m3 {
          width: 135px;
          height: 30px;
          background-image: var(--rc-topline-logo-rambler-small-bgImage);
        }

        .rc__7t272a.rc__2p7qpq .rc__36gd3d {
          height: 30px;
          background-position: 0 0.5px;
        }
      .rc__7t272a.rc__3164cf {
        flex-direction: column;
        align-items: flex-start;
      }

        .rc__7t272a.rc__3164cf .rc__8k27m3 {
          width: 135px;
          height: 30px;
          background-image: var(--rc-topline-logo-rambler-small-bgImage);
        }

        .rc__7t272a.rc__3164cf .rc__36gd3d {
          height: 30px;
          background-position: 0 0.5px;
        }
      .rc__7t272a.rc__5gus6x {
        flex-direction: column;
        align-items: flex-start;
      }

        .rc__7t272a.rc__5gus6x .rc__8k27m3 {
          width: 135px;
          height: 30px;
          background-image: var(--rc-topline-logo-rambler-small-bgImage);
        }

        .rc__7t272a.rc__5gus6x .rc__36gd3d {
          height: 30px;
          background-position: 0 0.5px;
        }
  }

.rc__8k27m3 {
  display: block;
  width: 145px;
  height: 40px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: var(--rc-topline-logo-rambler-bgImage);
}

.rc__36gd3d {
  display: block;
  height: 40px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 0 10.5px;
}

.rc__5spb97 .rc__36gd3d {
    width: 230px;
    background-image: var(--rc-topline-logo-ai-bgImage);
  }

.rc__5t81we .rc__36gd3d {
    width: 39px;
    background-image: var(--rc-topline-logo-auto-bgImage);
  }

.rc__6a6v2r .rc__36gd3d {
    width: 80px;
    background-image: var(--rc-topline-logo-doctor-bgImage);
  }

.rc__7ezxn4 .rc__36gd3d {
    width: 90px;
    background-image: var(--rc-topline-logo-dom-bgImage);
  }

.rc__2ycc71 .rc__36gd3d {
    width: 141px;
    background-image: var(--rc-topline-logo-family-bgImage);
  }

.rc__7d1wxy .rc__36gd3d {
    width: 152px;
    background-image: var(--rc-topline-logo-finance-bgImage);
  }

.rc__4gmqv4 .rc__36gd3d {
    width: 73px;
    background-image: var(--rc-topline-logo-help-bgImage);
  }

.rc__5xnt8h .rc__36gd3d {
    width: 189px;
    background-image: var(--rc-topline-logo-life-bgImage);
  }

.rc__5z88xh .rc__36gd3d {
    width: 74px;
    background-image: var(--rc-topline-logo-news-bgImage);
  }

.rc__8fxnng .rc__36gd3d {
    width: 66px;
    background-image: var(--rc-topline-logo-pro-bgImage);
  }

.rc__2p7qpq .rc__36gd3d {
    width: 184px;
    background-image: var(--rc-topline-logo-sci-bgImage);
  }

.rc__4akbn7 .rc__36gd3d {
    width: 44px;
    background-image: var(--rc-topline-logo-soft-bgImage);
  }

.rc__5buba6 .rc__36gd3d {
    width: 52px;
    background-image: var(--rc-topline-logo-sport-bgImage);
  }

.rc__3164cf .rc__36gd3d {
    width: 181px;
    background-image: var(--rc-topline-logo-weekend-bgImage);
  }

.rc__suhjmx .rc__36gd3d {
    width: 96px;
    background-image: var(--rc-topline-logo-horoscopes-bgImage);
  }

.rc__5gus6x .rc__36gd3d {
    width: 133px;
    background-image: var(--rc-topline-logo-tv-bgImage);
  }

.rc__38kka2 .rc__36gd3d {
    width: 63px;
    background-image: var(--rc-topline-logo-weather-bgImage);
  }

.rc__5faufn .rc__36gd3d {
    width: 44px;
    background-image: var(--rc-topline-logo-kino-bgImage);
  }

.rc__6xxs5j .rc__36gd3d {
    width: 110px;
    background-image: var(--rc-topline-logo-travel-bgImage);
  }

.rc__2sdv74 .rc__36gd3d {
    width: 79px;
    background-image: var(--rc-topline-logo-woman-bgImage);
  }

.rc__n3b9u3 {
  display: flex;
  align-items: center;
  height: var(--rc-topline-height);
}

.rc__4jqs5s {
  display: flex;
  align-items: center;
  -webkit-text-decoration: none;
  text-decoration: none;
  height: 30px;
}

.rc__8cy3va {
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  margin-right: 5px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.rc__8cy3va.rc__3h9tyd {
      background-image: var(--rc-topline-product-advertising-bgImage);
    }

.rc__8cy3va.rc__6jj9hy {
      background-image: var(--rc-topline-product-ai-bgImage);
    }

.rc__8cy3va.rc__2wczpr {
      background-image: var(--rc-topline-product-auto-bgImage);
    }

.rc__8cy3va.rc__55d7k6 {
      background-image: var(--rc-topline-product-dating-bgImage);
    }

.rc__8cy3va.rc__8qz4sj {
      background-image: var(--rc-topline-product-doctor-bgImage);
    }

.rc__8cy3va.rc__cn8dpf {
      background-image: var(--rc-topline-product-dom-bgImage);
    }

.rc__8cy3va.rc__3ph95q {
      background-image: var(--rc-topline-product-family-bgImage);
    }

.rc__8cy3va.rc__475a6x {
      background-image: var(--rc-topline-product-finance-bgImage);
    }

.rc__8cy3va.rc__6355xf {
      background-image: var(--rc-topline-product-help-bgImage);
    }

.rc__8cy3va.rc__45qan5 {
      background-image: var(--rc-topline-product-home-bgImage);
    }

.rc__8cy3va.rc__66mjxt {
      background-image: var(--rc-topline-product-horoscopes-bgImage);
    }

.rc__8cy3va.rc__23p48a {
      background-image: var(--rc-topline-product-id-bgImage);
    }

.rc__8cy3va.rc__8u2vnh {
      background-image: var(--rc-topline-product-images-bgImage);
    }

.rc__8cy3va.rc__rvab5e {
      background-image: var(--rc-topline-product-kino-bgImage);
    }

.rc__8cy3va.rc__31pwm5 {
      background-image: var(--rc-topline-product-life-bgImage);
    }

.rc__8cy3va.rc__6kuyqd {
      background-image: var(--rc-topline-product-likes-bgImage);
    }

.rc__8cy3va.rc__79egbp {
      background-image: var(--rc-topline-product-mail-bgImage);
    }

.rc__8cy3va.rc__2bxhdu {
      background-image: var(--rc-topline-product-more-bgImage);
    }

.rc__8cy3va.rc__74fuu9 {
      background-image: var(--rc-topline-product-news-bgImage);
    }

.rc__8cy3va.rc__7vnfy8 {
      background-image: var(--rc-topline-product-pro-bgImage);
    }

.rc__8cy3va.rc__81dzh1 {
      background-image: var(--rc-topline-product-sci-bgImage);
    }

.rc__8cy3va.rc__6vduyn {
      background-image: var(--rc-topline-product-search-bgImage);
    }

.rc__8cy3va.rc__8bk39f {
      background-image: var(--rc-topline-product-sport-bgImage);
    }

.rc__8cy3va.rc__6xyfsh {
      background-image: var(--rc-topline-product-starlife-bgImage);
    }

.rc__8cy3va.rc__2j6jgk {
      background-image: var(--rc-topline-product-terms-bgImage);
    }

.rc__8cy3va.rc__41u6rn {
      background-image: var(--rc-topline-product-top100-bgImage);
    }

.rc__8cy3va.rc__7te1tt {
      background-image: var(--rc-topline-product-travel-bgImage);
    }

.rc__8cy3va.rc__4ubdjp {
      background-image: var(--rc-topline-product-tv-bgImage);
    }

.rc__8cy3va.rc__3drdas {
      background-image: var(--rc-topline-product-weather-bgImage);
    }

.rc__8cy3va.rc__3tgcp9 {
      background-image: var(--rc-topline-product-weekend-bgImage);
    }

.rc__8cy3va.rc__85msep {
      background-image: var(--rc-topline-product-woman-bgImage);
    }

.rc__jme3a3 {
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  color: var(--rc-topline-color);
  white-space: nowrap;
}

@media (hover: hover) {

.rc__jme3a3 {
    transition: color 200ms
}

    .rc__4jqs5s:hover .rc__jme3a3 {
      color: var(--rc-topline-link-hover-color);
    }
  }

.rc__4jqs5s:active .rc__jme3a3 {
    color: var(--rc-topline-link-active-color);
  }

.rc__5anmk5 {
  position: absolute;
  overflow: hidden;
  display: flex;
  top: 60px;
  right: 0;
  border-radius: 20px;
  background-color: var(--rc-topline-bgColor);
  box-shadow: var(--rc-topline-boxShadow);
  transform: translateX(calc(50% - 32px));
  transition: opacity 200ms 50ms;
  pointer-events: none;
  opacity: 0;
  z-index: 1;
}

  .rc__5anmk5.rc__7j9zc4 {
    pointer-events: auto;
  }

  .rc__5anmk5.rc__4cz22q {
    transition: opacity 200ms;
    opacity: 1;
  }

.rc__ujw4dk,
.rc__6nme8z {
  padding: 20px;
}

.rc__6nme8z {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  background-color: var(--rc-topline-extra-bgColor);
}

.rc__364bhv {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.rc__4jhd6r {
  position: relative;
  margin-right: 40px;
}

.rc__87za64 {
  display: flex;
  -moz-column-gap: 20px;
       column-gap: 20px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.rc__84kpwh {
  display: flex;
  align-items: center;
  height: var(--rc-topline-height);
}

/* stylelint-disable selector-class-pattern, selector-id-pattern */
.rc__4cfwtg {
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.rc__4cfwtg.rc__6wncmy {
    opacity: 0;
  }
.rc__4cfwtg .button {
      background-color: transparent !important;
    }
.rc__4cfwtg .button-link {
      outline: revert !important;
    }
.rc__4cfwtg .button-link {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 30px;
      min-width: 30px;
    }
.rc__4cfwtg .button__image-container {
      display: block;
      width: 30px;
      height: 30px;
      background-position: center;
      background-size: cover;
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    }
.rc__4cfwtg .button__text-container {
      overflow: hidden;
      display: block;
      max-width: 165px;
      font-family: "Manrope", sans-serif;
      font-size: 15px;
      font-weight: 500;
      line-height: 20px;
      color: var(--rc-topline-color);
      white-space: nowrap;
      text-overflow: ellipsis;
    }
.rc__4cfwtg .button__image-container + .button__text-container {
      margin-left: 5px;
    }
@media (hover: hover) {
      .rc__4cfwtg .button__image-container {
        transition: opacity 200ms;
      }

      .rc__4cfwtg .button__text-container {
        transition: color 200ms;
      }
        .rc__4cfwtg .button-link:hover .button__image-container {
          opacity: 0.9;
        }

        .rc__4cfwtg .button-link:hover .button__text-container {
          color: var(--rc-topline-link-hover-color);
        }
    }
.rc__4cfwtg .button-link:active .button__image-container {
        opacity: 0.8;
      }
.rc__4cfwtg .button-link:active .button__text-container {
        color: var(--rc-topline-link-active-color);
      }
.rc__4cfwtg.rc__6pa522 .button__text-container {
    display: none;
  }
/* Стили без иконки */
.rc__4cfwtg.rc__7dqqe9 .button__text-container {
      max-width: 200px;
    }
.rc__4cfwtg.rc__7dqqe9.rc__6pa522 .button {
      display: none;
    }
/* stylelint-enable */

.rc__5qyerc {
  position: relative;
  display: flex;
  align-items: center;
  height: 20px;
  padding: 0 5px;
  border-radius: 10px 10px 10px 0;

/*   <svg xmlns="http://www.w3.org/2000/svg" width="85" height="20" fill="none" viewBox="0 0 85 20"><path fill="#0C9C0C" d="M0 0h86v20H0Z"/><path fill="url(#a)" d="M0 0h86v20H0Z"/><path fill="url(#b)" d="M0 0h86v20H0Z"/><path fill="url(#c)" d="M0 0h86v20H0Z"/><path fill="url(#d)" d="M0 0h86v20H0Z"/><defs><radialGradient id="a" cx="0" cy="0" r="1" gradientTransform="scale(45.6288 20.2156)" gradientUnits="userSpaceOnUse"><stop stop-color="#15D015"/><stop offset="1" stop-color="#15D015" stop-opacity="0"/></radialGradient><radialGradient id="b" cx="0" cy="0" r="1" gradientTransform="matrix(46.1503 0 0 35.2609 -3.65 0)" gradientUnits="userSpaceOnUse"><stop stop-color="#FAED05"/><stop offset="1" stop-color="#0C9C0C" stop-opacity="0"/></radialGradient><radialGradient id="c" cx="0" cy="0" r="1" gradientTransform="matrix(-32.8528 0 0 -13.7214 88.26 0)" gradientUnits="userSpaceOnUse"><stop stop-color="#42E3B4"/><stop offset="1" stop-color="#15D015" stop-opacity="0"/></radialGradient><radialGradient id="d" cx="0" cy="0" r="1" gradientTransform="matrix(-83.4356 0 0 -36.8191 85 20)" gradientUnits="userSpaceOnUse"><stop stop-color="#129DFA"/><stop offset="1" stop-color="#15D015" stop-opacity="0"/></radialGradient></defs></svg> */

  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 100% 100%;
}

.rc__6dspxx {
  overflow: hidden;
  display: block;
  max-width: 57px;
  font-family: "Manrope", sans-serif;
  font-size: 13px;
  font-weight: 800;
  line-height: 20px;
  color: #ffffff;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.rc__5tfe5j {
  width: 10px;
  height: 10px;
  margin-left: 5px;
}


.rc__2hekhu {
  position: absolute;
  overflow: hidden;
  top: 45px;
  right: 0;
  border-radius: 20px;
  background-color: var(--rc-topline-bgColor);
  box-shadow: var(--rc-topline-boxShadow);
  transition: opacity 200ms 50ms;
  pointer-events: none;
  opacity: 0;
  z-index: 1;
}

  .rc__2hekhu.rc__4qxthh {
    pointer-events: auto;
  }

  .rc__2hekhu.rc__5cc1g3 {
    transition: opacity 200ms;
    opacity: 1;
  }

.rc__2fuukt {
  width: 320px;
  padding: 20px;
}

.rc__vcnvy1 {
  padding: 20px;
  background-color: var(--rc-topline-extra-bgColor);
}

.rc__281djj {
  position: relative;
  padding-left: 50px;
}

.rc__4bddk5 {
  position: absolute;
  display: block;
  width: 40px;
  height: 40px;
  top: 0;
  left: 0;
  border-radius: 20px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-color: var(--rc-topline-avatar-bgColor);
}

.rc__4d23hz {
  padding: 0;
  border: 0;
  background-color: transparent;
  box-shadow: none;
  cursor: pointer;

  display: flex;
  color: var(--rc-topline-email-color);
  cursor: pointer;
}

@media (hover: hover) {

.rc__4d23hz {
    transition: color 200ms
}

    .rc__4d23hz:not(.rc__6swnax):hover {
      color: var(--rc-topline-link-hover-color);
    }
  }

.rc__4d23hz:not(.rc__6swnax):active {
    color: var(--rc-topline-link-active-color);
  }

.rc__4d23hz.rc__6swnax {
    cursor: default;
  }

.rc__2zzp3r,
.rc__gm8dvv {
  overflow: hidden;
  display: block;
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rc__2zzp3r {
  color: var(--rc-topline-color);
}

.rc__gm8dvv {
  position: relative;
  max-width: 205px;
}

.rc__6swnax .rc__gm8dvv {
    min-width: 100px;
    color: var(--rc-topline-email-copied-color);
    transition: none;
  }

.rc__6swnax .rc__gm8dvv::after {
      position: absolute;
      overflow: hidden;
      width: 100%;
      top: 0;
      left: 0;
      content: "Скопировано";
      color: var(--rc-topline-email-color);
      white-space: nowrap;
      text-overflow: ellipsis;
    }

.rc__3gj2h4 {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  margin: 20px 0 0;
  padding: 0 0 0 50px;
  list-style: none;
}

.rc__641zgq {
  position: relative;
}

.rc__5mt5kr,
.rc__3psfat {
  padding: 0;
  border: 0;
  background-color: transparent;
  box-shadow: none;
  cursor: pointer;

  color: var(--rc-topline-link-color);
}

@media (hover: hover) {

.rc__5mt5kr,
.rc__3psfat {
    transition: color 200ms
}

    .rc__5mt5kr:hover, .rc__3psfat:hover {
      color: var(--rc-topline-link-hover-color);
    }
  }

.rc__5mt5kr:active, .rc__3psfat:active {
    color: var(--rc-topline-link-active-color);
  }

.rc__5mt5kr {
  padding: 0;
  border: 0;
  background-color: transparent;
  box-shadow: none;
  cursor: pointer;

  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  cursor: pointer;
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
  -webkit-text-decoration: none;
  text-decoration: none;
}

.rc__3psfat {
  display: flex;
  align-items: center;
}

.rc__72y1as {
  overflow: hidden;
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.rc__69sk4m {
  position: relative;
  flex-shrink: 0;
  display: block;
  width: 20px;
  height: 20px;
  z-index: 0;
}

.rc__4d23hz .rc__69sk4m {
    margin-left: 5px;
  }

.rc__6swnax .rc__69sk4m {
    opacity: 0;
  }

.rc__3psfat .rc__69sk4m {
    margin-right: 5px;
  }

.rc__69sk4m::before {
  content: "";
  position: absolute;
  width: 30px;
  height: 30px;
  top: -5px;
  left: -5px;
  border-radius: 15px;
  background-color: var(--rc-topline-area-bgColor);
  transform: scale(0.1);
  z-index: -1;
}

@media (hover: hover) {

.rc__69sk4m::before {
    transition: background-color 100ms, transform 100ms
}

    .rc__4d23hz:hover .rc__69sk4m::before,
    .rc__3psfat:hover .rc__69sk4m::before {
      background-color: var(--rc-topline-area-hover-bgColor);
      transform: scale(1);
    }
  }

.rc__4d23hz:active .rc__69sk4m::before,
  .rc__3psfat:active .rc__69sk4m::before {
    background-color: var(--rc-topline-area-active-bgColor);
    transform: scale(1);
  }

.rc__zssa91 {
  width: 20px;
  height: 20px;
}

/* sber spasibo */

.rc__8s5j7g {
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  color: var(--rc-topline-color);
  white-space: pre-line;
}

.rc__7nmte3 {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  vertical-align: bottom;
}

.rc__4unprz {
  padding: 0;
  border: 0;
  background-color: transparent;
  box-shadow: none;
  cursor: pointer;

  display: flex;
  align-items: center;
  margin-left: -30px;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 20px;
  color: var(--rc-topline-spasibo-link-color);
}

@media (hover: hover) {

.rc__4unprz {
    transition: color 200ms
}

    .rc__4unprz:hover {
      color: var(--rc-topline-spasibo-link-hover-color);
    }
  }

.rc__4unprz:active {
    color: var(--rc-topline-spasibo-link-active-color);
  }

.rc__4unprz .rc__skawhj {
    margin-right: 10px;
  }

.rc__4xz9g2 {
  display: flex;
  align-items: center;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  color: var(--rc-topline-color);
}

.rc__4xz9g2 .rc__skawhj {
    margin-left: 5px;
  }

.rc__4vr1rd {
  margin-left: 10px;
  font-weight: 700;
}

.rc__skawhj {
  width: 20px;
  height: 20px;
}

.rc__bwm8dr {
  position: relative;
  display: flex;
  margin-left: 40px;
}

  .rc__bwm8dr.rc__81eh5z {
    flex-grow: 1;
    justify-content: flex-end;
    margin-left: 0;
  }

.rc__5hxkd5 {
  display: flex;
  align-items: center;
  height: 30px;
  color: var(--rc-topline-color);
  -webkit-text-decoration: none;
  text-decoration: none;
}

@media (hover: hover) {

.rc__5hxkd5 {
    transition: color 200ms
}

    .rc__5hxkd5:hover {
      color: var(--rc-topline-link-hover-color);
    }
  }

.rc__5hxkd5:active {
    color: var(--rc-topline-link-active-color);
  }

.rc__5dmhhz {
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 20px;
}

.rc__5s869u {
  width: 20px;
  height: 20px;
  margin-left: 5px;
}

.rc__2ygtg7 {
  position: relative;
  font-size: 0;
}

.rc__74mqt4 {
  padding: 0;
  border: 0;
  background-color: transparent;
  box-shadow: none;
  cursor: pointer;

  display: flex;
  align-items: center;
  font-size: 0;
}

.rc__32gpef {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-color: var(--rc-topline-avatar-bgColor);
}

@media (hover: hover) {

.rc__32gpef {
    transition: opacity 200ms
}

    .rc__74mqt4:hover .rc__32gpef {
      opacity: 0.9;
    }
  }

.rc__74mqt4:active .rc__32gpef {
    opacity: 0.8;
  }

.rc__7rj5yf {
  margin-left: -10px;
}

/* На ультра узких экранах с логотипом не умещается, поэтому скрываем */

@media (max-width: 1039px) {

.rc__4h7r7k .rc__7rj5yf {
      display: none
  }
    }

.rc__3kxhbe {
  position: absolute;
  overflow: hidden;
  display: none;
  flex-direction: column;
  width: 600px;
  top: 45px;
  left: 0;
  right: 0;
  padding: 10px;
  border-radius: 20px;
  background-color: var(--rc-topline-suggest-bgColor);
  box-shadow: var(--rc-topline-suggest-boxShadow);
}

  .rc__3kxhbe.rc__2y4n74 {
    display: flex;
  }

.rc__3qsrd4,
.rc__7ncb7k {
  position: relative;
  width: 100%;
  border-radius: 15px;
}

.rc__3qsrd4.rc__3nqm6p, .rc__7ncb7k.rc__3nqm6p {
    background-color: var(--rc-topline-area-hover-bgColor);
  }

@media (hover: hover) {

.rc__3qsrd4,
.rc__7ncb7k {
    transition: background-color 200ms
}

    .rc__3qsrd4:hover, .rc__7ncb7k:hover {
      background-color: var(--rc-topline-area-hover-bgColor);
    }
  }

.rc__3qsrd4:active, .rc__7ncb7k:active {
    background-color: var(--rc-topline-area-active-bgColor);
  }

.rc__3qsrd4 + .rc__7ncb7k {
  margin-top: 21px;
}

.rc__3qsrd4 + .rc__7ncb7k::before {
    content: "";
    position: absolute;
    top: -11px;
    left: 0;
    right: 0;
    border-top: var(--rc-topline-suddgest-separator-border);
  }

.rc__2vc5ru {
  padding: 0;
  border: 0;
  background-color: transparent;
  box-shadow: none;
  cursor: pointer;

  overflow: hidden;
  width: 100%;
  padding: 10px;
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--rc-topline-color);
}

.rc__2vc5ru b {
    font-weight: 700;
    color: var(--rc-topline-link-color);
  }

.rc__cduvpz {
  position: relative;
}

.rc__6x1w84 {
  position: relative;
  width: 100%;
}

.rc__86etrn {
  width: 100%;
  height: 40px;
  padding: 0 55px 0 15px;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  color: var(--rc-topline-search-color);
  border: 0;
  border-radius: 20px;
  background-color: var(--rc-topline-search-bgColor);
  box-shadow: var(--rc-topline-search-boxShadow);
}

.rc__6jatxs .rc__86etrn {
    padding: 0 95px 0 15px;
  }

.rc__86etrn::-moz-placeholder {
    opacity: 1 !important;
  }

.rc__86etrn::placeholder {
    opacity: 1 !important;
  }

.rc__86etrn::-moz-placeholder {
    color: var(--rc-topline-search-placeholder-color);
    -moz-transition: color 200ms;
    transition: color 200ms;
  }

.rc__86etrn::placeholder {
    color: var(--rc-topline-search-placeholder-color);
    transition: color 200ms;
  }

@media (hover: hover) {
    .rc__86etrn:hover::-moz-placeholder {
      color: var(--rc-topline-search-placeholder-hover-color);
    }
    .rc__86etrn:hover::placeholder {
      color: var(--rc-topline-search-placeholder-hover-color);
    }
  }

.rc__86etrn:focus::-moz-placeholder {
    color: var(--rc-topline-search-placeholder-active-color);
  }

.rc__86etrn:focus::placeholder {
    color: var(--rc-topline-search-placeholder-active-color);
  }

.rc__3vg6ke {
  padding: 0;
  border: 0;
  background-color: transparent;
  box-shadow: none;
  cursor: pointer;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  top: 0;
  font-size: 0;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  color: var(--rc-topline-search-button-color);
}

@media (hover: hover) {

.rc__3vg6ke {
    transition: color 200ms
}

    .rc__3vg6ke:hover {
      color: var(--rc-topline-search-button-hover-color);
    }
  }

.rc__3vg6ke:active {
    color: var(--rc-topline-search-button-active-color);
  }

.rc__2grc97 {
  right: 40px;
}

.rc__3hgafm {
  right: 0;
}

.rc__6jatxs .rc__3hgafm {
    color: var(--rc-topline-search-button-done-color);
  }

.rc__7c3w4t {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  background-color: var(--rc-topline-search-button-bgColor);
}

.rc__6jatxs .rc__7c3w4t {
    background-color: var(--rc-topline-search-button-done-bgColor);
  }

@media (hover: hover) {

.rc__7c3w4t {
    transition: background-color 200ms
}

    .rc__3vg6ke:hover .rc__7c3w4t {
      background-color: var(--rc-topline-search-button-hover-bgColor);
    }

      .rc__6jatxs .rc__3vg6ke:hover .rc__7c3w4t {
        background-color: var(--rc-topline-search-button-done-hover-bgColor);
      }
  }

.rc__3vg6ke:active .rc__7c3w4t {
    background-color: var(--rc-topline-search-button-active-bgColor);
  }

.rc__6jatxs .rc__3vg6ke:active .rc__7c3w4t {
      background-color: var(--rc-topline-search-button-done-active-bgColor);
    }

.rc__4sdj3f {
  display: block;
  width: 20px;
  height: 20px;
}

.rc__4452ca {
  margin-right: 40px;
}

.rc__455adm {
  display: flex;
  align-items: center;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 20px;
  color: var(--rc-topline-color);
  -webkit-text-decoration: none;
  text-decoration: none;
}

@media (hover: hover) {

.rc__455adm {
    transition: color 200ms
}

    .rc__455adm:hover {
      color: var(--rc-topline-link-hover-color);
    }
  }

.rc__455adm:active {
    color: var(--rc-topline-link-active-color);
  }

.rc__3r6n6x {
  width: 40px;
  height: 40px;
  margin: 0 5px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.rc__3r6n6x.rc__27xt8r {
      background-image: var(--rc-topline-weather-clear-night-bgImage);
    }

.rc__3r6n6x.rc__5zhdf9 {
      background-image: var(--rc-topline-weather-clear-bgImage);
    }

.rc__3r6n6x.rc__xt7jq7 {
      background-image: var(--rc-topline-weather-cloudy-bgImage);
    }

.rc__3r6n6x.rc__8v5q8h {
      background-image: var(--rc-topline-weather-fog-bgImage);
    }

.rc__3r6n6x.rc__vs2d54 {
      background-image: var(--rc-topline-weather-light-rain-night-bgImage);
    }

.rc__3r6n6x.rc__4wnk8h {
      background-image: var(--rc-topline-weather-light-rain-bgImage);
    }

.rc__3r6n6x.rc__5pdzvf {
      background-image: var(--rc-topline-weather-light-snow-night-bgImage);
    }

.rc__3r6n6x.rc__jkq7au {
      background-image: var(--rc-topline-weather-light-snow-bgImage);
    }

.rc__3r6n6x.rc__8bb85a {
      background-image: var(--rc-topline-weather-occ-light-rain-bgImage);
    }

.rc__3r6n6x.rc__34k51a {
      background-image: var(--rc-topline-weather-occ-light-snow-bgImage);
    }

.rc__3r6n6x.rc__7raptg {
      background-image: var(--rc-topline-weather-occ-rain-bgImage);
    }

.rc__3r6n6x.rc__5y4eyz {
      background-image: var(--rc-topline-weather-occ-sleet-bgImage);
    }

.rc__3r6n6x.rc__23264t {
      background-image: var(--rc-topline-weather-occ-snow-bgImage);
    }

.rc__3r6n6x.rc__5es4fh {
      background-image: var(--rc-topline-weather-partly-cloudy-night-bgImage);
    }

.rc__3r6n6x.rc__3nswtn {
      background-image: var(--rc-topline-weather-partly-cloudy-bgImage);
    }

.rc__3r6n6x.rc__4zhh54 {
      background-image: var(--rc-topline-weather-rain-night-bgImage);
    }

.rc__3r6n6x.rc__5h2mrz {
      background-image: var(--rc-topline-weather-rain-bgImage);
    }

.rc__3r6n6x.rc__52quam {
      background-image: var(--rc-topline-weather-sleet-night-bgImage);
    }

.rc__3r6n6x.rc__7ezgu1 {
      background-image: var(--rc-topline-weather-sleet-bgImage);
    }

.rc__3r6n6x.rc__5a16hm {
      background-image: var(--rc-topline-weather-snow-night-bgImage);
    }

.rc__3r6n6x.rc__5szg7w {
      background-image: var(--rc-topline-weather-snow-bgImage);
    }

.rc__3r6n6x.rc__4faj6p {
      background-image: var(--rc-topline-weather-thunder-bgImage);
    }

@media (max-width: 1155px) {

.rc__5h5w22 .rc__33zx77 {
      display: none
  }
    }

.rc__7uf3m5 {
  display: flex;
  align-items: center;
  -moz-column-gap: 20px;
       column-gap: 20px;
  margin-right: 40px;
}

.rc__8b6d8y {
  display: flex;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 20px;
  -webkit-text-decoration: none;
  text-decoration: none;
}

.rc__5x7r7w {
  display: inline-flex;
  color: var(--rc-topline-exchangeRates-currecy-color);
  margin-right: 5px;
}

.rc__5wh9q9 {
  color: var(--rc-topline-color);
}

@media (hover: hover) {

.rc__5x7r7w,
.rc__5wh9q9 {
    transition: color 200ms
}

    .rc__8b6d8y:hover .rc__5x7r7w, .rc__8b6d8y:hover .rc__5wh9q9 {
      color: var(--rc-topline-link-hover-color);
    }
  }

.rc__8b6d8y:active .rc__5x7r7w, .rc__8b6d8y:active .rc__5wh9q9 {
    color: var(--rc-topline-link-active-color);
  }

.rc__7f3k5k {
  display: inline-flex;
  width: 20px;
  height: 20px;
  color: var(--rc-topline-exchangeRates-up-color);
}

.rc__7f3k5k.rc__4h3kud {
    color: var(--rc-topline-exchangeRates-down-color);
    transform: rotate(180deg);
  }

.rc__4wrhdz {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  margin-right: 40px;
}

.rc__56h59c {
  display: flex;
  gap: 10px;
}

  .rc__56h59c.rc__ekn5np {
    flex-grow: 1;
    justify-content: flex-end;
  }

.rc__29x3bb {
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
  -webkit-text-decoration: none;
  text-decoration: none;
}

.rc__4axx6f {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  z-index: 0;
}

.rc__8zuf4g .rc__4axx6f::after {
    content: "";
    position: absolute;
    width: 10px;
    height: 10px;
    right: 2.5px;
    bottom: 5px;
    border-radius: 5px;
    background: var(--rc-topline-ui-unread-bg);
    z-index: 1;
  }

.rc__4axx6f::before {
  content: "";
  position: absolute;
  width: 40px;
  height: 40px;
  top: 0;
  left: 0;
  border-radius: 20px;
  background-color: var(--rc-topline-area-bgColor);
  transform: scale(0.1);
  z-index: -1;
}

@media (hover: hover) {

.rc__4axx6f::before {
    transition: background-color 100ms, transform 100ms
}

    .rc__29x3bb:hover .rc__4axx6f::before {
      background-color: var(--rc-topline-area-hover-bgColor);
      transform: scale(1);
    }
  }

.rc__29x3bb:active .rc__4axx6f::before {
    background-color: var(--rc-topline-area-active-bgColor);
    transform: scale(1);
  }

.rc__2pq3vx {
  display: block;
  width: 25px;
  height: 25px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.rc__2bcj7b .rc__2pq3vx {
    background-image: var(--rc-topline-ui-icon-mail-bgImage);
  }

.rc__72616a {
  margin-left: 5px;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 20px;
  color: var(--rc-topline-color);
}

@media (hover: hover) {

.rc__72616a {
    transition: color 200ms
}

    .rc__29x3bb:hover .rc__72616a {
      color: var(--rc-topline-link-hover-color);
    }
  }

.rc__29x3bb:active .rc__72616a {
    color: var(--rc-topline-link-active-color);
  }

@media (max-width: 1210px) {

.rc__2bcj7b.rc__8dd4rx .rc__72616a {
      display: none
  }
    }

.rc__5xfz3h {
  flex-grow: 1;
  margin-right: 40px;
}

:root {
  --rc-topline-height: 70px;
  --rc-topline-header-height: 60px;

  --rc-topline-color: #343b4c;
  --rc-topline-link-color: #315efb;
  --rc-topline-link-hover-color: #2c54e2;
  --rc-topline-link-active-color: #274bc8;
  --rc-topline-email-color: #777e98;
  --rc-topline-email-copied-color: rgba(119,126,152, 0);

  --rc-topline-bgColor: #ffffff;
  --rc-topline-extra-bgColor: #eff5ff;
  --rc-topline-avatar-bgColor: #eff5ff;
  --rc-topline-boxShadow: 0 5px 30px -10px rgba(49,94,251, 0.3);

  --rc-topline-search-color: #343b4c;
  --rc-topline-search-bgColor: #ffffff;
  --rc-topline-search-boxShadow: 0 10px 20px -5px rgba(49,94,251, 0.15);
  --rc-topline-search-placeholder-color: #315efb;
  --rc-topline-search-placeholder-hover-color: rgba(49,94,251, 0.7);
  --rc-topline-search-placeholder-active-color: #afb6c9;
  --rc-topline-search-colorEllipse-bg: linear-gradient(90deg, #315EFB 20%, #00E8FF 60%, #00FFB3 90%, #00E8FF 100%);
  --rc-topline-search-blueEllipse-bg: rgba(49,94,251, 0.15);

  --rc-topline-search-button-color: #315efb;
  --rc-topline-search-button-bgColor: #eff5ff;
  --rc-topline-search-button-hover-color: #2c54e2;
  --rc-topline-search-button-hover-bgColor: #e0ebff;
  --rc-topline-search-button-active-color: #274bc8;
  --rc-topline-search-button-active-bgColor: #d1e2ff;

  --rc-topline-search-button-done-color: #ffffff;
  --rc-topline-search-button-done-bgColor: #315efb;
  --rc-topline-search-button-done-hover-bgColor: #2c54e2;
  --rc-topline-search-button-done-active-bgColor: #274bc8;

  --rc-topline-area-bgColor: transparent;
  --rc-topline-area-hover-bgColor: #eff5ff;
  --rc-topline-area-active-bgColor: #e0ebff;

  --rc-topline-suggest-bgColor: #ffffff;
  --rc-topline-suggest-boxShadow: 0 10px 30px -5px rgba(49,94,251, 0.30);
  --rc-topline-suddgest-separator-border: 1px solid #e0ebff;

  --rc-topline-ui-unread-bg: radial-gradient(66.13% 81.39% at 65% 20%, #ff807a 0%, #ff3c32 100%);

  --rc-topline-exchangeRates-currecy-color: #8d96b2;
  --rc-topline-exchangeRates-up-color: #28bc00;
  --rc-topline-exchangeRates-down-color: #ff564e;

  --rc-topline-spasibo-link-color: #21ba72;
  --rc-topline-spasibo-link-hover-color: #1ea767;
  --rc-topline-spasibo-link-active-color: #1a955b;
    --rc-topline-product-advertising-bgImage: url("https://static.rambler.ru/assets/v2/product/140/advertising.svg?1")
;
    --rc-topline-product-ai-bgImage: url("https://static.rambler.ru/assets/v2/product/140/ai.svg?1")
;
    --rc-topline-product-auto-bgImage: url("https://static.rambler.ru/assets/v2/product/140/auto.svg?1")
;
    --rc-topline-product-dating-bgImage: url("https://static.rambler.ru/assets/v2/product/140/dating.svg?1")
;
    --rc-topline-product-doctor-bgImage: url("https://static.rambler.ru/assets/v2/product/140/doctor.svg?1")
;
    --rc-topline-product-dom-bgImage: url("https://static.rambler.ru/assets/v2/product/140/dom.svg?1")
;
    --rc-topline-product-family-bgImage: url("https://static.rambler.ru/assets/v2/product/140/family.svg?1")
;
    --rc-topline-product-finance-bgImage: url("https://static.rambler.ru/assets/v2/product/140/finance.svg?1")
;
    --rc-topline-product-help-bgImage: url("https://static.rambler.ru/assets/v2/product/140/help.svg?1")
;
    --rc-topline-product-home-bgImage: url("https://static.rambler.ru/assets/v2/product/140/home.svg?1")
;
    --rc-topline-product-horoscopes-bgImage: url("https://static.rambler.ru/assets/v2/product/140/horoscopes.svg?1")
;
    --rc-topline-product-id-bgImage: url("https://static.rambler.ru/assets/v2/product/140/id.svg?1")
;
    --rc-topline-product-images-bgImage: url("https://static.rambler.ru/assets/v2/product/140/images.svg?1")
;
    --rc-topline-product-kino-bgImage: url("https://static.rambler.ru/assets/v2/product/140/kino.svg?1")
;
    --rc-topline-product-life-bgImage: url("https://static.rambler.ru/assets/v2/product/140/life.svg?1")
;
    --rc-topline-product-likes-bgImage: url("https://static.rambler.ru/assets/v2/product/140/likes.svg?1")
;
    --rc-topline-product-mail-bgImage: url("https://static.rambler.ru/assets/v2/product/140/mail.svg?1")
;
    --rc-topline-product-more-bgImage: url("https://static.rambler.ru/assets/v2/product/140/more.svg?1")
;
    --rc-topline-product-news-bgImage: url("https://static.rambler.ru/assets/v2/product/140/news.svg?1")
;
    --rc-topline-product-pro-bgImage: url("https://static.rambler.ru/assets/v2/product/140/pro.svg?1")
;
    --rc-topline-product-sci-bgImage: url("https://static.rambler.ru/assets/v2/product/140/sci.svg?1")
;
    --rc-topline-product-search-bgImage: url("https://static.rambler.ru/assets/v2/product/140/search.svg?1")
;
    --rc-topline-product-sport-bgImage: url("https://static.rambler.ru/assets/v2/product/140/sport.svg?1")
;
    --rc-topline-product-starlife-bgImage: url("https://static.rambler.ru/assets/v2/product/140/starlife.svg?1")
;
    --rc-topline-product-terms-bgImage: url("https://static.rambler.ru/assets/v2/product/140/terms.svg?1")
;
    --rc-topline-product-top100-bgImage: url("https://static.rambler.ru/assets/v2/product/140/top100.svg?1")
;
    --rc-topline-product-travel-bgImage: url("https://static.rambler.ru/assets/v2/product/140/travel.svg?1")
;
    --rc-topline-product-tv-bgImage: url("https://static.rambler.ru/assets/v2/product/140/tv.svg?1")
;
    --rc-topline-product-weather-bgImage: url("https://static.rambler.ru/assets/v2/product/140/weather.svg?1")
;
    --rc-topline-product-weekend-bgImage: url("https://static.rambler.ru/assets/v2/product/140/weekend.svg?1")
;
    --rc-topline-product-woman-bgImage: url("https://static.rambler.ru/assets/v2/product/140/woman.svg?1")
;
    --rc-topline-logo-rambler-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/rambler.svg?1")
;
    --rc-topline-logo-rambler-small-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/rambler-small.svg?1")
;
    --rc-topline-logo-ai-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/ai.svg?1")
;
    --rc-topline-logo-auto-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/auto.svg?1")
;
    --rc-topline-logo-doctor-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/doctor.svg?1")
;
    --rc-topline-logo-dom-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/dom.svg?1")
;
    --rc-topline-logo-family-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/family.svg?1")
;
    --rc-topline-logo-finance-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/finance.svg?1")
;
    --rc-topline-logo-help-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/help.svg?1")
;
    --rc-topline-logo-life-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/life.svg?1")
;
    --rc-topline-logo-news-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/news.svg?1")
;
    --rc-topline-logo-pro-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/pro.svg?1")
;
    --rc-topline-logo-sci-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/sci.svg?1")
;
    --rc-topline-logo-soft-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/soft.svg?1")
;
    --rc-topline-logo-sport-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/sport.svg?1")
;
    --rc-topline-logo-weekend-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/weekend.svg?1")
;
    --rc-topline-logo-horoscopes-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/horoscopes.svg?1")
;
    --rc-topline-logo-tv-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/tv.svg?1")
;
    --rc-topline-logo-weather-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/weather.svg?1")
;
    --rc-topline-logo-kino-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/kino.svg?1")
;
    --rc-topline-logo-travel-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/travel.svg?1")
;
    --rc-topline-logo-woman-bgImage: url("https://static.rambler.ru/assets/v2/logotypes/woman.svg?1")
;
    --rc-topline-ui-icon-calendar-bgImage: url("https://static.rambler.ru/assets/v2/product/16/calendar.svg")
;
    --rc-topline-ui-icon-comments-bgImage: url("https://static.rambler.ru/assets/v2/product/16/comments.svg")
;
    --rc-topline-ui-icon-mail-bgImage: url("https://static.rambler.ru/assets/v2/product/16/mail.svg")
;
    --rc-topline-weather-clear-night-bgImage: url("https://static.rambler.ru/assets/weather/30/clear-night.svg")
;
    --rc-topline-weather-clear-bgImage: url("https://static.rambler.ru/assets/weather/30/clear.svg")
;
    --rc-topline-weather-cloudy-bgImage: url("https://static.rambler.ru/assets/weather/30/cloudy.svg")
;
    --rc-topline-weather-fog-bgImage: url("https://static.rambler.ru/assets/weather/30/fog.svg")
;
    --rc-topline-weather-light-rain-night-bgImage: url("https://static.rambler.ru/assets/weather/30/light-rain-night.svg")
;
    --rc-topline-weather-light-rain-bgImage: url("https://static.rambler.ru/assets/weather/30/light-rain.svg")
;
    --rc-topline-weather-light-snow-night-bgImage: url("https://static.rambler.ru/assets/weather/30/light-snow-night.svg")
;
    --rc-topline-weather-light-snow-bgImage: url("https://static.rambler.ru/assets/weather/30/light-snow.svg")
;
    --rc-topline-weather-occ-light-rain-bgImage: url("https://static.rambler.ru/assets/weather/30/occ-light-rain.svg")
;
    --rc-topline-weather-occ-light-snow-bgImage: url("https://static.rambler.ru/assets/weather/30/occ-light-snow.svg")
;
    --rc-topline-weather-occ-rain-bgImage: url("https://static.rambler.ru/assets/weather/30/occ-rain.svg")
;
    --rc-topline-weather-occ-sleet-bgImage: url("https://static.rambler.ru/assets/weather/30/occ-sleet.svg")
;
    --rc-topline-weather-occ-snow-bgImage: url("https://static.rambler.ru/assets/weather/30/occ-snow.svg")
;
    --rc-topline-weather-partly-cloudy-night-bgImage: url("https://static.rambler.ru/assets/weather/30/partly-cloudy-night.svg")
;
    --rc-topline-weather-partly-cloudy-bgImage: url("https://static.rambler.ru/assets/weather/30/partly-cloudy.svg")
;
    --rc-topline-weather-rain-night-bgImage: url("https://static.rambler.ru/assets/weather/30/rain-night.svg")
;
    --rc-topline-weather-rain-bgImage: url("https://static.rambler.ru/assets/weather/30/rain.svg")
;
    --rc-topline-weather-sleet-night-bgImage: url("https://static.rambler.ru/assets/weather/30/sleet-night.svg")
;
    --rc-topline-weather-sleet-bgImage: url("https://static.rambler.ru/assets/weather/30/sleet.svg")
;
    --rc-topline-weather-snow-night-bgImage: url("https://static.rambler.ru/assets/weather/30/snow-night.svg")
;
    --rc-topline-weather-snow-bgImage: url("https://static.rambler.ru/assets/weather/30/snow.svg")
;
    --rc-topline-weather-thunder-bgImage: url("https://static.rambler.ru/assets/weather/30/thunder.svg")

}

.rc__3asvyx {
  position: relative;
  min-width: 1010px;
  background-color: var(--rc-topline-bgColor);
  z-index: 15;
}

.rc__215akj,
.rc__2bj87v {
  position: absolute;
  overflow: hidden;
  left: 0;
  right: 0;
  opacity: 0;
  transition: opacity 400ms;
  pointer-events: none;
}

.rc__215akj.rc__8j93cj, .rc__2bj87v.rc__8j93cj {
    opacity: 0.8;
  }

.rc__215akj .rc__5fwmzw,
  .rc__215akj .rc__48e6jv,
  .rc__2bj87v .rc__5fwmzw,
  .rc__2bj87v .rc__48e6jv {
    position: absolute;
    height: 200px;
    border-radius: 100%;
    background: var(--rc-topline-search-colorEllipse-bg);
    filter: blur(50px);
  }

.rc__215akj {
  top: 0;
  bottom: 0;
}

.rc__215akj .rc__5fwmzw {
    bottom: -199px;
  }

.rc__2bj87v {
  height: 150px;
  top: 100%;
}

.rc__2bj87v .rc__5fwmzw {
    top: -199px;
  }

.rc__6ajzxr {
  position: relative;
  height: var(--rc-topline-height);
  z-index: 2;
}

.rc__6ajzxr .rc__8wcknd {
    height: var(--rc-topline-height);
  }

.rc__3yjsqa {
  width: 100%;
  min-width: 1010px;
}

.rc__3yjsqa.rc__2nv4nm {
    position: fixed;
    top: -70px;
    left: 0;
    transform: translate(0, 0);
    transition: transform 200ms;
    z-index: 15;
  }

.rc__3yjsqa.rc__2nv4nm.rc__25r65k {
      box-shadow: var(--rc-topline-boxShadow);
    }

.rc__3yjsqa.rc__7y64ha {
    background-color: var(--rc-topline-bgColor);
    transform: translate(0, 70px);
  }

.rc__6mqu3t {
  position: relative;
  z-index: 1;
}

.rc__6mqu3t .rc__8wcknd {
    height: var(--rc-topline-header-height);
  }

.rc__8wcknd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;
}

@media (min-width: 1300px) {

.rc__51k77w {
    width: 1260px;
    padding-left: 0;
    padding-right: 0
}
  }

`, "",{"version":3,"sources":["webpack://./node_modules/@rambler-components/topline/styles.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,oBAAoB;OACf,eAAe;EACpB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;MACM;QACE,sBAAsB;QACtB,uBAAuB;MACzB;;QAEE;UACE,YAAY;UACZ,YAAY;UACZ,8DAA8D;QAChE;;QAEA;UACE,YAAY;UACZ,4BAA4B;QAC9B;MACF;QACE,sBAAsB;QACtB,uBAAuB;MACzB;;QAEE;UACE,YAAY;UACZ,YAAY;UACZ,8DAA8D;QAChE;;QAEA;UACE,YAAY;UACZ,4BAA4B;QAC9B;MACF;QACE,sBAAsB;QACtB,uBAAuB;MACzB;;QAEE;UACE,YAAY;UACZ,YAAY;UACZ,8DAA8D;QAChE;;QAEA;UACE,YAAY;UACZ,4BAA4B;QAC9B;MACF;QACE,sBAAsB;QACtB,uBAAuB;MACzB;;QAEE;UACE,YAAY;UACZ,YAAY;UACZ,8DAA8D;QAChE;;QAEA;UACE,YAAY;UACZ,4BAA4B;QAC9B;MACF;QACE,sBAAsB;QACtB,uBAAuB;MACzB;;QAEE;UACE,YAAY;UACZ,YAAY;UACZ,8DAA8D;QAChE;;QAEA;UACE,YAAY;UACZ,4BAA4B;QAC9B;MACF;QACE,sBAAsB;QACtB,uBAAuB;MACzB;;QAEE;UACE,YAAY;UACZ,YAAY;UACZ,8DAA8D;QAChE;;QAEA;UACE,YAAY;UACZ,4BAA4B;QAC9B;MACF;QACE,sBAAsB;QACtB,uBAAuB;MACzB;;QAEE;UACE,YAAY;UACZ,YAAY;UACZ,8DAA8D;QAChE;;QAEA;UACE,YAAY;UACZ,4BAA4B;QAC9B;EACN;;AAEF;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;IACI,YAAY;IACZ,mDAAmD;EACrD;;AAEF;IACI,WAAW;IACX,qDAAqD;EACvD;;AAEF;IACI,WAAW;IACX,uDAAuD;EACzD;;AAEF;IACI,WAAW;IACX,oDAAoD;EACtD;;AAEF;IACI,YAAY;IACZ,uDAAuD;EACzD;;AAEF;IACI,YAAY;IACZ,wDAAwD;EAC1D;;AAEF;IACI,WAAW;IACX,qDAAqD;EACvD;;AAEF;IACI,YAAY;IACZ,qDAAqD;EACvD;;AAEF;IACI,WAAW;IACX,qDAAqD;EACvD;;AAEF;IACI,WAAW;IACX,oDAAoD;EACtD;;AAEF;IACI,YAAY;IACZ,oDAAoD;EACtD;;AAEF;IACI,WAAW;IACX,qDAAqD;EACvD;;AAEF;IACI,WAAW;IACX,sDAAsD;EACxD;;AAEF;IACI,YAAY;IACZ,wDAAwD;EAC1D;;AAEF;IACI,WAAW;IACX,2DAA2D;EAC7D;;AAEF;IACI,YAAY;IACZ,mDAAmD;EACrD;;AAEF;IACI,WAAW;IACX,wDAAwD;EAC1D;;AAEF;IACI,WAAW;IACX,qDAAqD;EACvD;;AAEF;IACI,YAAY;IACZ,uDAAuD;EACzD;;AAEF;IACI,WAAW;IACX,sDAAsD;EACxD;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;MACM,+DAA+D;IACjE;;AAEJ;MACM,sDAAsD;IACxD;;AAEJ;MACM,wDAAwD;IAC1D;;AAEJ;MACM,0DAA0D;IAC5D;;AAEJ;MACM,0DAA0D;IAC5D;;AAEJ;MACM,uDAAuD;IACzD;;AAEJ;MACM,0DAA0D;IAC5D;;AAEJ;MACM,2DAA2D;IAC7D;;AAEJ;MACM,wDAAwD;IAC1D;;AAEJ;MACM,wDAAwD;IAC1D;;AAEJ;MACM,8DAA8D;IAChE;;AAEJ;MACM,sDAAsD;IACxD;;AAEJ;MACM,0DAA0D;IAC5D;;AAEJ;MACM,wDAAwD;IAC1D;;AAEJ;MACM,wDAAwD;IAC1D;;AAEJ;MACM,yDAAyD;IAC3D;;AAEJ;MACM,wDAAwD;IAC1D;;AAEJ;MACM,wDAAwD;IAC1D;;AAEJ;MACM,wDAAwD;IAC1D;;AAEJ;MACM,uDAAuD;IACzD;;AAEJ;MACM,uDAAuD;IACzD;;AAEJ;MACM,0DAA0D;IAC5D;;AAEJ;MACM,yDAAyD;IAC3D;;AAEJ;MACM,4DAA4D;IAC9D;;AAEJ;MACM,yDAAyD;IAC3D;;AAEJ;MACM,0DAA0D;IAC5D;;AAEJ;MACM,0DAA0D;IAC5D;;AAEJ;MACM,sDAAsD;IACxD;;AAEJ;MACM,2DAA2D;IAC7D;;AAEJ;MACM,2DAA2D;IAC7D;;AAEJ;MACM,yDAAyD;IAC3D;;AAEJ;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;AAEA;IACI;AACJ;;IAEI;MACE,yCAAyC;IAC3C;EACF;;AAEF;IACI,0CAA0C;EAC5C;;AAEF;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,2CAA2C;EAC3C,uCAAuC;EACvC,uCAAuC;EACvC,8BAA8B;EAC9B,oBAAoB;EACpB,UAAU;EACV,UAAU;AACZ;;EAEE;IACE,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,UAAU;EACZ;;AAEF;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;OAChB,gBAAgB;EACrB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;IACI,UAAU;EACZ;AACF;MACM,wCAAwC;IAC1C;AACJ;MACM,0BAA0B;IAC5B;AACJ;MACM,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,YAAY;MACZ,eAAe;IACjB;AACJ;MACM,cAAc;MACd,WAAW;MACX,YAAY;MACZ,2BAA2B;MAC3B,sBAAsB;MACtB,yDAAiiB;IACniB;AACJ;MACM,gBAAgB;MAChB,cAAc;MACd,gBAAgB;MAChB,kCAAkC;MAClC,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,8BAA8B;MAC9B,mBAAmB;MACnB,uBAAuB;IACzB;AACJ;MACM,gBAAgB;IAClB;AACJ;MACM;QACE,yBAAyB;MAC3B;;MAEA;QACE,uBAAuB;MACzB;QACE;UACE,YAAY;QACd;;QAEA;UACE,yCAAyC;QAC3C;IACJ;AACJ;QACQ,YAAY;MACd;AACN;QACQ,0CAA0C;MAC5C;AACN;IACI,aAAa;EACf;AACF,qBAAqB;AACrB;MACM,gBAAgB;IAClB;AACJ;MACM,aAAa;IACf;AACJ,qBAAqB;;AAErB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,+BAA+B;;AAEjC,ktCAAktC;;EAEhtC,yDAA06E;EAC16E,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,2CAA2C;EAC3C,uCAAuC;EACvC,8BAA8B;EAC9B,oBAAoB;EACpB,UAAU;EACV,UAAU;AACZ;;EAEE;IACE,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,UAAU;EACZ;;AAEF;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;;EAEf,aAAa;EACb,oCAAoC;EACpC,eAAe;AACjB;;AAEA;;AAEA;IACI;AACJ;;IAEI;MACE,yCAAyC;IAC3C;EACF;;AAEF;IACI,0CAA0C;EAC5C;;AAEF;IACI,eAAe;EACjB;;AAEF;;EAEE,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;IACI,gBAAgB;IAChB,2CAA2C;IAC3C,gBAAgB;EAClB;;AAEF;MACM,kBAAkB;MAClB,gBAAgB;MAChB,WAAW;MACX,MAAM;MACN,OAAO;MACP,sBAAsB;MACtB,oCAAoC;MACpC,mBAAmB;MACnB,uBAAuB;IACzB;;AAEJ;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;;EAEf,mCAAmC;AACrC;;AAEA;;AAEA;;IAEI;AACJ;;IAEI;MACE,yCAAyC;IAC3C;EACF;;AAEF;IACI,0CAA0C;EAC5C;;AAEF;EACE,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;;EAEf,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;IACI,gBAAgB;EAClB;;AAEF;IACI,UAAU;EACZ;;AAEF;IACI,iBAAiB;EACnB;;AAEF;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,gDAAgD;EAChD,qBAAqB;EACrB,WAAW;AACb;;AAEA;;AAEA;IACI;AACJ;;IAEI;;MAEE,sDAAsD;MACtD,mBAAmB;IACrB;EACF;;AAEF;;IAEI,uDAAuD;IACvD,mBAAmB;EACrB;;AAEF;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iBAAiB;;AAEjB;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;;AAEA;IACI;AACJ;;IAEI;MACE,iDAAiD;IACnD;EACF;;AAEF;IACI,kDAAkD;EACpD;;AAEF;IACI,kBAAkB;EACpB;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;IACI,gBAAgB;EAClB;;AAEF;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;EAEE;IACE,YAAY;IACZ,yBAAyB;IACzB,cAAc;EAChB;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;AAEA;IACI;AACJ;;IAEI;MACE,yCAAyC;IAC3C;EACF;;AAEF;IACI,0CAA0C;EAC5C;;AAEF;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;;AAEA;IACI;AACJ;;IAEI;MACE,YAAY;IACd;EACF;;AAEF;IACI,YAAY;EACd;;AAEF;EACE,kBAAkB;AACpB;;AAEA,uEAAuE;;AAEvE;;AAEA;MACM;EACJ;IACE;;AAEJ;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,mDAAmD;EACnD,+CAA+C;AACjD;;EAEE;IACE,aAAa;EACf;;AAEF;;EAEE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;IACI,sDAAsD;EACxD;;AAEF;;AAEA;;IAEI;AACJ;;IAEI;MACE,sDAAsD;IACxD;EACF;;AAEF;IACI,uDAAuD;EACzD;;AAEF;EACE,gBAAgB;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,QAAQ;IACR,uDAAuD;EACzD;;AAEF;EACE,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;;EAEf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;EACrC;;AAEF;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,kDAAkD;EAClD,8CAA8C;AAChD;;AAEA;IACI,sBAAsB;EACxB;;AAEF;IACI,qBAAqB;EACvB;;AAEF;IACI,qBAAqB;EACvB;;AAEF;IACI,iDAAiD;IACjD,4BAA4B;IAC5B,uBAAuB;EACzB;;AAEF;IACI,iDAAiD;IACjD,uBAAuB;EACzB;;AAEF;IACI;MACE,uDAAuD;IACzD;IACA;MACE,uDAAuD;IACzD;EACF;;AAEF;IACI,wDAAwD;EAC1D;;AAEF;IACI,wDAAwD;EAC1D;;AAEF;EACE,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;;EAEf,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,MAAM;EACN,YAAY;EACZ,yBAAyB;KACtB,sBAAsB;UACjB,iBAAiB;EACzB,4CAA4C;AAC9C;;AAEA;;AAEA;IACI;AACJ;;IAEI;MACE,kDAAkD;IACpD;EACF;;AAEF;IACI,mDAAmD;EACrD;;AAEF;EACE,WAAW;AACb;;AAEA;EACE,QAAQ;AACV;;AAEA;IACI,iDAAiD;EACnD;;AAEF;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;IACI,8DAA8D;EAChE;;AAEF;;AAEA;IACI;AACJ;;IAEI;MACE,+DAA+D;IACjE;;MAEE;QACE,oEAAoE;MACtE;EACJ;;AAEF;IACI,gEAAgE;EAClE;;AAEF;MACM,qEAAqE;IACvE;;AAEJ;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;AAEA;IACI;AACJ;;IAEI;MACE,yCAAyC;IAC3C;EACF;;AAEF;IACI,0CAA0C;EAC5C;;AAEF;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;MACM,+DAA+D;IACjE;;AAEJ;MACM,yDAAyD;IAC3D;;AAEJ;MACM,0DAA0D;IAC5D;;AAEJ;MACM,uDAAuD;IACzD;;AAEJ;MACM,oEAAoE;IACtE;;AAEJ;MACM,8DAA8D;IAChE;;AAEJ;MACM,oEAAoE;IACtE;;AAEJ;MACM,8DAA8D;IAChE;;AAEJ;MACM,kEAAkE;IACpE;;AAEJ;MACM,kEAAkE;IACpE;;AAEJ;MACM,4DAA4D;IAC9D;;AAEJ;MACM,6DAA6D;IAC/D;;AAEJ;MACM,4DAA4D;IAC9D;;AAEJ;MACM,uEAAuE;IACzE;;AAEJ;MACM,iEAAiE;IACnE;;AAEJ;MACM,8DAA8D;IAChE;;AAEJ;MACM,wDAAwD;IAC1D;;AAEJ;MACM,+DAA+D;IACjE;;AAEJ;MACM,yDAAyD;IAC3D;;AAEJ;MACM,8DAA8D;IAChE;;AAEJ;MACM,wDAAwD;IAC1D;;AAEJ;MACM,2DAA2D;IAC7D;;AAEJ;;AAEA;MACM;EACJ;IACE;;AAEJ;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;OAChB,gBAAgB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,oDAAoD;EACpD,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;AAEA;;IAEI;AACJ;;IAEI;MACE,yCAAyC;IAC3C;EACF;;AAEF;IACI,0CAA0C;EAC5C;;AAEF;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,+CAA+C;AACjD;;AAEA;IACI,iDAAiD;IACjD,yBAAyB;EAC3B;;AAEF;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;EAEE;IACE,YAAY;IACZ,yBAAyB;EAC3B;;AAEF;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,0CAA0C;IAC1C,UAAU;EACZ;;AAEF;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,mBAAmB;EACnB,gDAAgD;EAChD,qBAAqB;EACrB,WAAW;AACb;;AAEA;;AAEA;IACI;AACJ;;IAEI;MACE,sDAAsD;MACtD,mBAAmB;IACrB;EACF;;AAEF;IACI,uDAAuD;IACvD,mBAAmB;EACrB;;AAEF;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;IACI,wDAAwD;EAC1D;;AAEF;EACE,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;;AAEA;IACI;AACJ;;IAEI;MACE,yCAAyC;IAC3C;EACF;;AAEF;IACI,0CAA0C;EAC5C;;AAEF;;AAEA;MACM;EACJ;IACE;;AAEJ;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;;EAEhC,2BAA2B;EAC3B,gCAAgC;EAChC,sCAAsC;EACtC,uCAAuC;EACvC,iCAAiC;EACjC,qDAAqD;;EAErD,6BAA6B;EAC7B,mCAAmC;EACnC,oCAAoC;EACpC,6DAA6D;;EAE7D,kCAAkC;EAClC,oCAAoC;EACpC,qEAAqE;EACrE,8CAA8C;EAC9C,iEAAiE;EACjE,qDAAqD;EACrD,gHAAgH;EAChH,yDAAyD;;EAEzD,yCAAyC;EACzC,2CAA2C;EAC3C,+CAA+C;EAC/C,iDAAiD;EACjD,gDAAgD;EAChD,kDAAkD;;EAElD,8CAA8C;EAC9C,gDAAgD;EAChD,sDAAsD;EACtD,uDAAuD;;EAEvD,sCAAsC;EACtC,wCAAwC;EACxC,yCAAyC;;EAEzC,qCAAqC;EACrC,sEAAsE;EACtE,yDAAyD;;EAEzD,8FAA8F;;EAE9F,iDAAiD;EACjD,4CAA4C;EAC5C,8CAA8C;;EAE9C,wCAAwC;EACxC,8CAA8C;EAC9C,+CAA+C;IAC7C;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;AACJ;IACI;;AAEJ;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,2CAA2C;EAC3C,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;IACI,YAAY;EACd;;AAEF;;;;IAII,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,oDAAoD;IACpD,kBAAkB;EACpB;;AAEF;EACE,MAAM;EACN,SAAS;AACX;;AAEA;IACI,cAAc;EAChB;;AAEF;EACE,aAAa;EACb,SAAS;AACX;;AAEA;IACI,WAAW;EACb;;AAEF;EACE,kBAAkB;EAClB,gCAAgC;EAChC,UAAU;AACZ;;AAEA;IACI,gCAAgC;EAClC;;AAEF;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,OAAO;IACP,0BAA0B;IAC1B,2BAA2B;IAC3B,WAAW;EACb;;AAEF;MACM,uCAAuC;IACzC;;AAEJ;IACI,2CAA2C;IAC3C,6BAA6B;EAC/B;;AAEF;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;IACI,uCAAuC;EACzC;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;AAEA;IACI,aAAa;IACb,eAAe;IACf;AACJ;EACE","sourcesContent":[".rc__3w3c2z {\n  overflow: hidden;\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  height: var(--rc-topline-header-height);\n}\n\n.rc__5h5udh {\n  font-size: 0;\n  -webkit-text-decoration: none;\n  text-decoration: none;\n}\n\n.rc__3mbvr2 {\n  max-height: var(--rc-topline-header-height);\n}\n\n.rc__7t272a {\n  display: flex;\n  -moz-column-gap: 2px;\n       column-gap: 2px;\n  margin-right: 40px;\n  flex-shrink: 0;\n  flex-direction: row;\n  align-items: center;\n}\n\n@media (max-width: 1299px) {\n      .rc__7t272a.rc__5spb97 {\n        flex-direction: column;\n        align-items: flex-start;\n      }\n\n        .rc__7t272a.rc__5spb97 .rc__8k27m3 {\n          width: 135px;\n          height: 30px;\n          background-image: var(--rc-topline-logo-rambler-small-bgImage);\n        }\n\n        .rc__7t272a.rc__5spb97 .rc__36gd3d {\n          height: 30px;\n          background-position: 0 0.5px;\n        }\n      .rc__7t272a.rc__2ycc71 {\n        flex-direction: column;\n        align-items: flex-start;\n      }\n\n        .rc__7t272a.rc__2ycc71 .rc__8k27m3 {\n          width: 135px;\n          height: 30px;\n          background-image: var(--rc-topline-logo-rambler-small-bgImage);\n        }\n\n        .rc__7t272a.rc__2ycc71 .rc__36gd3d {\n          height: 30px;\n          background-position: 0 0.5px;\n        }\n      .rc__7t272a.rc__7d1wxy {\n        flex-direction: column;\n        align-items: flex-start;\n      }\n\n        .rc__7t272a.rc__7d1wxy .rc__8k27m3 {\n          width: 135px;\n          height: 30px;\n          background-image: var(--rc-topline-logo-rambler-small-bgImage);\n        }\n\n        .rc__7t272a.rc__7d1wxy .rc__36gd3d {\n          height: 30px;\n          background-position: 0 0.5px;\n        }\n      .rc__7t272a.rc__5xnt8h {\n        flex-direction: column;\n        align-items: flex-start;\n      }\n\n        .rc__7t272a.rc__5xnt8h .rc__8k27m3 {\n          width: 135px;\n          height: 30px;\n          background-image: var(--rc-topline-logo-rambler-small-bgImage);\n        }\n\n        .rc__7t272a.rc__5xnt8h .rc__36gd3d {\n          height: 30px;\n          background-position: 0 0.5px;\n        }\n      .rc__7t272a.rc__2p7qpq {\n        flex-direction: column;\n        align-items: flex-start;\n      }\n\n        .rc__7t272a.rc__2p7qpq .rc__8k27m3 {\n          width: 135px;\n          height: 30px;\n          background-image: var(--rc-topline-logo-rambler-small-bgImage);\n        }\n\n        .rc__7t272a.rc__2p7qpq .rc__36gd3d {\n          height: 30px;\n          background-position: 0 0.5px;\n        }\n      .rc__7t272a.rc__3164cf {\n        flex-direction: column;\n        align-items: flex-start;\n      }\n\n        .rc__7t272a.rc__3164cf .rc__8k27m3 {\n          width: 135px;\n          height: 30px;\n          background-image: var(--rc-topline-logo-rambler-small-bgImage);\n        }\n\n        .rc__7t272a.rc__3164cf .rc__36gd3d {\n          height: 30px;\n          background-position: 0 0.5px;\n        }\n      .rc__7t272a.rc__5gus6x {\n        flex-direction: column;\n        align-items: flex-start;\n      }\n\n        .rc__7t272a.rc__5gus6x .rc__8k27m3 {\n          width: 135px;\n          height: 30px;\n          background-image: var(--rc-topline-logo-rambler-small-bgImage);\n        }\n\n        .rc__7t272a.rc__5gus6x .rc__36gd3d {\n          height: 30px;\n          background-position: 0 0.5px;\n        }\n  }\n\n.rc__8k27m3 {\n  display: block;\n  width: 145px;\n  height: 40px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: var(--rc-topline-logo-rambler-bgImage);\n}\n\n.rc__36gd3d {\n  display: block;\n  height: 40px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: 0 10.5px;\n}\n\n.rc__5spb97 .rc__36gd3d {\n    width: 230px;\n    background-image: var(--rc-topline-logo-ai-bgImage);\n  }\n\n.rc__5t81we .rc__36gd3d {\n    width: 39px;\n    background-image: var(--rc-topline-logo-auto-bgImage);\n  }\n\n.rc__6a6v2r .rc__36gd3d {\n    width: 80px;\n    background-image: var(--rc-topline-logo-doctor-bgImage);\n  }\n\n.rc__7ezxn4 .rc__36gd3d {\n    width: 90px;\n    background-image: var(--rc-topline-logo-dom-bgImage);\n  }\n\n.rc__2ycc71 .rc__36gd3d {\n    width: 141px;\n    background-image: var(--rc-topline-logo-family-bgImage);\n  }\n\n.rc__7d1wxy .rc__36gd3d {\n    width: 152px;\n    background-image: var(--rc-topline-logo-finance-bgImage);\n  }\n\n.rc__4gmqv4 .rc__36gd3d {\n    width: 73px;\n    background-image: var(--rc-topline-logo-help-bgImage);\n  }\n\n.rc__5xnt8h .rc__36gd3d {\n    width: 189px;\n    background-image: var(--rc-topline-logo-life-bgImage);\n  }\n\n.rc__5z88xh .rc__36gd3d {\n    width: 74px;\n    background-image: var(--rc-topline-logo-news-bgImage);\n  }\n\n.rc__8fxnng .rc__36gd3d {\n    width: 66px;\n    background-image: var(--rc-topline-logo-pro-bgImage);\n  }\n\n.rc__2p7qpq .rc__36gd3d {\n    width: 184px;\n    background-image: var(--rc-topline-logo-sci-bgImage);\n  }\n\n.rc__4akbn7 .rc__36gd3d {\n    width: 44px;\n    background-image: var(--rc-topline-logo-soft-bgImage);\n  }\n\n.rc__5buba6 .rc__36gd3d {\n    width: 52px;\n    background-image: var(--rc-topline-logo-sport-bgImage);\n  }\n\n.rc__3164cf .rc__36gd3d {\n    width: 181px;\n    background-image: var(--rc-topline-logo-weekend-bgImage);\n  }\n\n.rc__suhjmx .rc__36gd3d {\n    width: 96px;\n    background-image: var(--rc-topline-logo-horoscopes-bgImage);\n  }\n\n.rc__5gus6x .rc__36gd3d {\n    width: 133px;\n    background-image: var(--rc-topline-logo-tv-bgImage);\n  }\n\n.rc__38kka2 .rc__36gd3d {\n    width: 63px;\n    background-image: var(--rc-topline-logo-weather-bgImage);\n  }\n\n.rc__5faufn .rc__36gd3d {\n    width: 44px;\n    background-image: var(--rc-topline-logo-kino-bgImage);\n  }\n\n.rc__6xxs5j .rc__36gd3d {\n    width: 110px;\n    background-image: var(--rc-topline-logo-travel-bgImage);\n  }\n\n.rc__2sdv74 .rc__36gd3d {\n    width: 79px;\n    background-image: var(--rc-topline-logo-woman-bgImage);\n  }\n\n.rc__n3b9u3 {\n  display: flex;\n  align-items: center;\n  height: var(--rc-topline-height);\n}\n\n.rc__4jqs5s {\n  display: flex;\n  align-items: center;\n  -webkit-text-decoration: none;\n  text-decoration: none;\n  height: 30px;\n}\n\n.rc__8cy3va {\n  flex-shrink: 0;\n  width: 30px;\n  height: 30px;\n  margin-right: 5px;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.rc__8cy3va.rc__3h9tyd {\n      background-image: var(--rc-topline-product-advertising-bgImage);\n    }\n\n.rc__8cy3va.rc__6jj9hy {\n      background-image: var(--rc-topline-product-ai-bgImage);\n    }\n\n.rc__8cy3va.rc__2wczpr {\n      background-image: var(--rc-topline-product-auto-bgImage);\n    }\n\n.rc__8cy3va.rc__55d7k6 {\n      background-image: var(--rc-topline-product-dating-bgImage);\n    }\n\n.rc__8cy3va.rc__8qz4sj {\n      background-image: var(--rc-topline-product-doctor-bgImage);\n    }\n\n.rc__8cy3va.rc__cn8dpf {\n      background-image: var(--rc-topline-product-dom-bgImage);\n    }\n\n.rc__8cy3va.rc__3ph95q {\n      background-image: var(--rc-topline-product-family-bgImage);\n    }\n\n.rc__8cy3va.rc__475a6x {\n      background-image: var(--rc-topline-product-finance-bgImage);\n    }\n\n.rc__8cy3va.rc__6355xf {\n      background-image: var(--rc-topline-product-help-bgImage);\n    }\n\n.rc__8cy3va.rc__45qan5 {\n      background-image: var(--rc-topline-product-home-bgImage);\n    }\n\n.rc__8cy3va.rc__66mjxt {\n      background-image: var(--rc-topline-product-horoscopes-bgImage);\n    }\n\n.rc__8cy3va.rc__23p48a {\n      background-image: var(--rc-topline-product-id-bgImage);\n    }\n\n.rc__8cy3va.rc__8u2vnh {\n      background-image: var(--rc-topline-product-images-bgImage);\n    }\n\n.rc__8cy3va.rc__rvab5e {\n      background-image: var(--rc-topline-product-kino-bgImage);\n    }\n\n.rc__8cy3va.rc__31pwm5 {\n      background-image: var(--rc-topline-product-life-bgImage);\n    }\n\n.rc__8cy3va.rc__6kuyqd {\n      background-image: var(--rc-topline-product-likes-bgImage);\n    }\n\n.rc__8cy3va.rc__79egbp {\n      background-image: var(--rc-topline-product-mail-bgImage);\n    }\n\n.rc__8cy3va.rc__2bxhdu {\n      background-image: var(--rc-topline-product-more-bgImage);\n    }\n\n.rc__8cy3va.rc__74fuu9 {\n      background-image: var(--rc-topline-product-news-bgImage);\n    }\n\n.rc__8cy3va.rc__7vnfy8 {\n      background-image: var(--rc-topline-product-pro-bgImage);\n    }\n\n.rc__8cy3va.rc__81dzh1 {\n      background-image: var(--rc-topline-product-sci-bgImage);\n    }\n\n.rc__8cy3va.rc__6vduyn {\n      background-image: var(--rc-topline-product-search-bgImage);\n    }\n\n.rc__8cy3va.rc__8bk39f {\n      background-image: var(--rc-topline-product-sport-bgImage);\n    }\n\n.rc__8cy3va.rc__6xyfsh {\n      background-image: var(--rc-topline-product-starlife-bgImage);\n    }\n\n.rc__8cy3va.rc__2j6jgk {\n      background-image: var(--rc-topline-product-terms-bgImage);\n    }\n\n.rc__8cy3va.rc__41u6rn {\n      background-image: var(--rc-topline-product-top100-bgImage);\n    }\n\n.rc__8cy3va.rc__7te1tt {\n      background-image: var(--rc-topline-product-travel-bgImage);\n    }\n\n.rc__8cy3va.rc__4ubdjp {\n      background-image: var(--rc-topline-product-tv-bgImage);\n    }\n\n.rc__8cy3va.rc__3drdas {\n      background-image: var(--rc-topline-product-weather-bgImage);\n    }\n\n.rc__8cy3va.rc__3tgcp9 {\n      background-image: var(--rc-topline-product-weekend-bgImage);\n    }\n\n.rc__8cy3va.rc__85msep {\n      background-image: var(--rc-topline-product-woman-bgImage);\n    }\n\n.rc__jme3a3 {\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 20px;\n  color: var(--rc-topline-color);\n  white-space: nowrap;\n}\n\n@media (hover: hover) {\n\n.rc__jme3a3 {\n    transition: color 200ms\n}\n\n    .rc__4jqs5s:hover .rc__jme3a3 {\n      color: var(--rc-topline-link-hover-color);\n    }\n  }\n\n.rc__4jqs5s:active .rc__jme3a3 {\n    color: var(--rc-topline-link-active-color);\n  }\n\n.rc__5anmk5 {\n  position: absolute;\n  overflow: hidden;\n  display: flex;\n  top: 60px;\n  right: 0;\n  border-radius: 20px;\n  background-color: var(--rc-topline-bgColor);\n  box-shadow: var(--rc-topline-boxShadow);\n  transform: translateX(calc(50% - 32px));\n  transition: opacity 200ms 50ms;\n  pointer-events: none;\n  opacity: 0;\n  z-index: 1;\n}\n\n  .rc__5anmk5.rc__7j9zc4 {\n    pointer-events: auto;\n  }\n\n  .rc__5anmk5.rc__4cz22q {\n    transition: opacity 200ms;\n    opacity: 1;\n  }\n\n.rc__ujw4dk,\n.rc__6nme8z {\n  padding: 20px;\n}\n\n.rc__6nme8z {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  background-color: var(--rc-topline-extra-bgColor);\n}\n\n.rc__364bhv {\n  display: flex;\n  flex-direction: column;\n  row-gap: 15px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.rc__4jhd6r {\n  position: relative;\n  margin-right: 40px;\n}\n\n.rc__87za64 {\n  display: flex;\n  -moz-column-gap: 20px;\n       column-gap: 20px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.rc__84kpwh {\n  display: flex;\n  align-items: center;\n  height: var(--rc-topline-height);\n}\n\n/* stylelint-disable selector-class-pattern, selector-id-pattern */\n.rc__4cfwtg {\n  display: flex;\n  overflow: hidden;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n.rc__4cfwtg.rc__6wncmy {\n    opacity: 0;\n  }\n.rc__4cfwtg .button {\n      background-color: transparent !important;\n    }\n.rc__4cfwtg .button-link {\n      outline: revert !important;\n    }\n.rc__4cfwtg .button-link {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: 30px;\n      min-width: 30px;\n    }\n.rc__4cfwtg .button__image-container {\n      display: block;\n      width: 30px;\n      height: 30px;\n      background-position: center;\n      background-size: cover;\n      background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8Y2lyY2xlIGN4PSIxMCIgY3k9IjEwIiByPSIxMCIgZmlsbD0iI0MxRDhGRiIvPgogIDxwYXRoIGZpbGw9IiM0QTdERkQiIGQ9Im0xMS4wNiA0LjY1IDUgNWEuNDguNDggMCAwIDEgMCAuN2wtNSA1YS40OTguNDk4IDAgMCAxLS43MSAwbC0uNy0uN2EuNS41IDAgMCAxIDAtLjcxTDEyLjU5IDExSDQuNWEuNS41IDAgMCAxLS41LS41di0xYS41LjUgMCAwIDEgLjUtLjVoOC4wOUw5LjY1IDYuMDZhLjUuNSAwIDAgMSAwLS43MWwuNy0uN2EuNS41IDAgMCAxIC43MSAwWiIvPgo8L3N2Zz4=);\n    }\n.rc__4cfwtg .button__text-container {\n      overflow: hidden;\n      display: block;\n      max-width: 165px;\n      font-family: \"Manrope\", sans-serif;\n      font-size: 15px;\n      font-weight: 500;\n      line-height: 20px;\n      color: var(--rc-topline-color);\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n.rc__4cfwtg .button__image-container + .button__text-container {\n      margin-left: 5px;\n    }\n@media (hover: hover) {\n      .rc__4cfwtg .button__image-container {\n        transition: opacity 200ms;\n      }\n\n      .rc__4cfwtg .button__text-container {\n        transition: color 200ms;\n      }\n        .rc__4cfwtg .button-link:hover .button__image-container {\n          opacity: 0.9;\n        }\n\n        .rc__4cfwtg .button-link:hover .button__text-container {\n          color: var(--rc-topline-link-hover-color);\n        }\n    }\n.rc__4cfwtg .button-link:active .button__image-container {\n        opacity: 0.8;\n      }\n.rc__4cfwtg .button-link:active .button__text-container {\n        color: var(--rc-topline-link-active-color);\n      }\n.rc__4cfwtg.rc__6pa522 .button__text-container {\n    display: none;\n  }\n/* Стили без иконки */\n.rc__4cfwtg.rc__7dqqe9 .button__text-container {\n      max-width: 200px;\n    }\n.rc__4cfwtg.rc__7dqqe9.rc__6pa522 .button {\n      display: none;\n    }\n/* stylelint-enable */\n\n.rc__5qyerc {\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 5px;\n  border-radius: 10px 10px 10px 0;\n\n/*   <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"85\" height=\"20\" fill=\"none\" viewBox=\"0 0 85 20\"><path fill=\"#0C9C0C\" d=\"M0 0h86v20H0Z\"/><path fill=\"url(#a)\" d=\"M0 0h86v20H0Z\"/><path fill=\"url(#b)\" d=\"M0 0h86v20H0Z\"/><path fill=\"url(#c)\" d=\"M0 0h86v20H0Z\"/><path fill=\"url(#d)\" d=\"M0 0h86v20H0Z\"/><defs><radialGradient id=\"a\" cx=\"0\" cy=\"0\" r=\"1\" gradientTransform=\"scale(45.6288 20.2156)\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#15D015\"/><stop offset=\"1\" stop-color=\"#15D015\" stop-opacity=\"0\"/></radialGradient><radialGradient id=\"b\" cx=\"0\" cy=\"0\" r=\"1\" gradientTransform=\"matrix(46.1503 0 0 35.2609 -3.65 0)\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#FAED05\"/><stop offset=\"1\" stop-color=\"#0C9C0C\" stop-opacity=\"0\"/></radialGradient><radialGradient id=\"c\" cx=\"0\" cy=\"0\" r=\"1\" gradientTransform=\"matrix(-32.8528 0 0 -13.7214 88.26 0)\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#42E3B4\"/><stop offset=\"1\" stop-color=\"#15D015\" stop-opacity=\"0\"/></radialGradient><radialGradient id=\"d\" cx=\"0\" cy=\"0\" r=\"1\" gradientTransform=\"matrix(-83.4356 0 0 -36.8191 85 20)\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#129DFA\"/><stop offset=\"1\" stop-color=\"#15D015\" stop-opacity=\"0\"/></radialGradient></defs></svg> */\n\n  background-image: url(data:image/jpeg;base64,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);\n  background-size: 100% 100%;\n}\n\n.rc__6dspxx {\n  overflow: hidden;\n  display: block;\n  max-width: 57px;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 13px;\n  font-weight: 800;\n  line-height: 20px;\n  color: #ffffff;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.rc__5tfe5j {\n  width: 10px;\n  height: 10px;\n  margin-left: 5px;\n}\n\n\n.rc__2hekhu {\n  position: absolute;\n  overflow: hidden;\n  top: 45px;\n  right: 0;\n  border-radius: 20px;\n  background-color: var(--rc-topline-bgColor);\n  box-shadow: var(--rc-topline-boxShadow);\n  transition: opacity 200ms 50ms;\n  pointer-events: none;\n  opacity: 0;\n  z-index: 1;\n}\n\n  .rc__2hekhu.rc__4qxthh {\n    pointer-events: auto;\n  }\n\n  .rc__2hekhu.rc__5cc1g3 {\n    transition: opacity 200ms;\n    opacity: 1;\n  }\n\n.rc__2fuukt {\n  width: 320px;\n  padding: 20px;\n}\n\n.rc__vcnvy1 {\n  padding: 20px;\n  background-color: var(--rc-topline-extra-bgColor);\n}\n\n.rc__281djj {\n  position: relative;\n  padding-left: 50px;\n}\n\n.rc__4bddk5 {\n  position: absolute;\n  display: block;\n  width: 40px;\n  height: 40px;\n  top: 0;\n  left: 0;\n  border-radius: 20px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  background-color: var(--rc-topline-avatar-bgColor);\n}\n\n.rc__4d23hz {\n  padding: 0;\n  border: 0;\n  background-color: transparent;\n  box-shadow: none;\n  cursor: pointer;\n\n  display: flex;\n  color: var(--rc-topline-email-color);\n  cursor: pointer;\n}\n\n@media (hover: hover) {\n\n.rc__4d23hz {\n    transition: color 200ms\n}\n\n    .rc__4d23hz:not(.rc__6swnax):hover {\n      color: var(--rc-topline-link-hover-color);\n    }\n  }\n\n.rc__4d23hz:not(.rc__6swnax):active {\n    color: var(--rc-topline-link-active-color);\n  }\n\n.rc__4d23hz.rc__6swnax {\n    cursor: default;\n  }\n\n.rc__2zzp3r,\n.rc__gm8dvv {\n  overflow: hidden;\n  display: block;\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 20px;\n  text-align: left;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rc__2zzp3r {\n  color: var(--rc-topline-color);\n}\n\n.rc__gm8dvv {\n  position: relative;\n  max-width: 205px;\n}\n\n.rc__6swnax .rc__gm8dvv {\n    min-width: 100px;\n    color: var(--rc-topline-email-copied-color);\n    transition: none;\n  }\n\n.rc__6swnax .rc__gm8dvv::after {\n      position: absolute;\n      overflow: hidden;\n      width: 100%;\n      top: 0;\n      left: 0;\n      content: \"Скопировано\";\n      color: var(--rc-topline-email-color);\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n\n.rc__3gj2h4 {\n  display: flex;\n  flex-direction: column;\n  row-gap: 15px;\n  margin: 20px 0 0;\n  padding: 0 0 0 50px;\n  list-style: none;\n}\n\n.rc__641zgq {\n  position: relative;\n}\n\n.rc__5mt5kr,\n.rc__3psfat {\n  padding: 0;\n  border: 0;\n  background-color: transparent;\n  box-shadow: none;\n  cursor: pointer;\n\n  color: var(--rc-topline-link-color);\n}\n\n@media (hover: hover) {\n\n.rc__5mt5kr,\n.rc__3psfat {\n    transition: color 200ms\n}\n\n    .rc__5mt5kr:hover, .rc__3psfat:hover {\n      color: var(--rc-topline-link-hover-color);\n    }\n  }\n\n.rc__5mt5kr:active, .rc__3psfat:active {\n    color: var(--rc-topline-link-active-color);\n  }\n\n.rc__5mt5kr {\n  padding: 0;\n  border: 0;\n  background-color: transparent;\n  box-shadow: none;\n  cursor: pointer;\n\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 20px;\n  cursor: pointer;\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n  white-space: nowrap;\n  -webkit-text-decoration: none;\n  text-decoration: none;\n}\n\n.rc__3psfat {\n  display: flex;\n  align-items: center;\n}\n\n.rc__72y1as {\n  overflow: hidden;\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 20px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.rc__69sk4m {\n  position: relative;\n  flex-shrink: 0;\n  display: block;\n  width: 20px;\n  height: 20px;\n  z-index: 0;\n}\n\n.rc__4d23hz .rc__69sk4m {\n    margin-left: 5px;\n  }\n\n.rc__6swnax .rc__69sk4m {\n    opacity: 0;\n  }\n\n.rc__3psfat .rc__69sk4m {\n    margin-right: 5px;\n  }\n\n.rc__69sk4m::before {\n  content: \"\";\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  top: -5px;\n  left: -5px;\n  border-radius: 15px;\n  background-color: var(--rc-topline-area-bgColor);\n  transform: scale(0.1);\n  z-index: -1;\n}\n\n@media (hover: hover) {\n\n.rc__69sk4m::before {\n    transition: background-color 100ms, transform 100ms\n}\n\n    .rc__4d23hz:hover .rc__69sk4m::before,\n    .rc__3psfat:hover .rc__69sk4m::before {\n      background-color: var(--rc-topline-area-hover-bgColor);\n      transform: scale(1);\n    }\n  }\n\n.rc__4d23hz:active .rc__69sk4m::before,\n  .rc__3psfat:active .rc__69sk4m::before {\n    background-color: var(--rc-topline-area-active-bgColor);\n    transform: scale(1);\n  }\n\n.rc__zssa91 {\n  width: 20px;\n  height: 20px;\n}\n\n/* sber spasibo */\n\n.rc__8s5j7g {\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 20px;\n  color: var(--rc-topline-color);\n  white-space: pre-line;\n}\n\n.rc__7nmte3 {\n  width: 20px;\n  height: 20px;\n  margin-right: 5px;\n  vertical-align: bottom;\n}\n\n.rc__4unprz {\n  padding: 0;\n  border: 0;\n  background-color: transparent;\n  box-shadow: none;\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n  margin-left: -30px;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 20px;\n  color: var(--rc-topline-spasibo-link-color);\n}\n\n@media (hover: hover) {\n\n.rc__4unprz {\n    transition: color 200ms\n}\n\n    .rc__4unprz:hover {\n      color: var(--rc-topline-spasibo-link-hover-color);\n    }\n  }\n\n.rc__4unprz:active {\n    color: var(--rc-topline-spasibo-link-active-color);\n  }\n\n.rc__4unprz .rc__skawhj {\n    margin-right: 10px;\n  }\n\n.rc__4xz9g2 {\n  display: flex;\n  align-items: center;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 20px;\n  color: var(--rc-topline-color);\n}\n\n.rc__4xz9g2 .rc__skawhj {\n    margin-left: 5px;\n  }\n\n.rc__4vr1rd {\n  margin-left: 10px;\n  font-weight: 700;\n}\n\n.rc__skawhj {\n  width: 20px;\n  height: 20px;\n}\n\n.rc__bwm8dr {\n  position: relative;\n  display: flex;\n  margin-left: 40px;\n}\n\n  .rc__bwm8dr.rc__81eh5z {\n    flex-grow: 1;\n    justify-content: flex-end;\n    margin-left: 0;\n  }\n\n.rc__5hxkd5 {\n  display: flex;\n  align-items: center;\n  height: 30px;\n  color: var(--rc-topline-color);\n  -webkit-text-decoration: none;\n  text-decoration: none;\n}\n\n@media (hover: hover) {\n\n.rc__5hxkd5 {\n    transition: color 200ms\n}\n\n    .rc__5hxkd5:hover {\n      color: var(--rc-topline-link-hover-color);\n    }\n  }\n\n.rc__5hxkd5:active {\n    color: var(--rc-topline-link-active-color);\n  }\n\n.rc__5dmhhz {\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 20px;\n}\n\n.rc__5s869u {\n  width: 20px;\n  height: 20px;\n  margin-left: 5px;\n}\n\n.rc__2ygtg7 {\n  position: relative;\n  font-size: 0;\n}\n\n.rc__74mqt4 {\n  padding: 0;\n  border: 0;\n  background-color: transparent;\n  box-shadow: none;\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n  font-size: 0;\n}\n\n.rc__32gpef {\n  display: block;\n  width: 40px;\n  height: 40px;\n  border-radius: 20px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  background-color: var(--rc-topline-avatar-bgColor);\n}\n\n@media (hover: hover) {\n\n.rc__32gpef {\n    transition: opacity 200ms\n}\n\n    .rc__74mqt4:hover .rc__32gpef {\n      opacity: 0.9;\n    }\n  }\n\n.rc__74mqt4:active .rc__32gpef {\n    opacity: 0.8;\n  }\n\n.rc__7rj5yf {\n  margin-left: -10px;\n}\n\n/* На ультра узких экранах с логотипом не умещается, поэтому скрываем */\n\n@media (max-width: 1039px) {\n\n.rc__4h7r7k .rc__7rj5yf {\n      display: none\n  }\n    }\n\n.rc__3kxhbe {\n  position: absolute;\n  overflow: hidden;\n  display: none;\n  flex-direction: column;\n  width: 600px;\n  top: 45px;\n  left: 0;\n  right: 0;\n  padding: 10px;\n  border-radius: 20px;\n  background-color: var(--rc-topline-suggest-bgColor);\n  box-shadow: var(--rc-topline-suggest-boxShadow);\n}\n\n  .rc__3kxhbe.rc__2y4n74 {\n    display: flex;\n  }\n\n.rc__3qsrd4,\n.rc__7ncb7k {\n  position: relative;\n  width: 100%;\n  border-radius: 15px;\n}\n\n.rc__3qsrd4.rc__3nqm6p, .rc__7ncb7k.rc__3nqm6p {\n    background-color: var(--rc-topline-area-hover-bgColor);\n  }\n\n@media (hover: hover) {\n\n.rc__3qsrd4,\n.rc__7ncb7k {\n    transition: background-color 200ms\n}\n\n    .rc__3qsrd4:hover, .rc__7ncb7k:hover {\n      background-color: var(--rc-topline-area-hover-bgColor);\n    }\n  }\n\n.rc__3qsrd4:active, .rc__7ncb7k:active {\n    background-color: var(--rc-topline-area-active-bgColor);\n  }\n\n.rc__3qsrd4 + .rc__7ncb7k {\n  margin-top: 21px;\n}\n\n.rc__3qsrd4 + .rc__7ncb7k::before {\n    content: \"\";\n    position: absolute;\n    top: -11px;\n    left: 0;\n    right: 0;\n    border-top: var(--rc-topline-suddgest-separator-border);\n  }\n\n.rc__2vc5ru {\n  padding: 0;\n  border: 0;\n  background-color: transparent;\n  box-shadow: none;\n  cursor: pointer;\n\n  overflow: hidden;\n  width: 100%;\n  padding: 10px;\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 20px;\n  text-align: left;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--rc-topline-color);\n}\n\n.rc__2vc5ru b {\n    font-weight: 700;\n    color: var(--rc-topline-link-color);\n  }\n\n.rc__cduvpz {\n  position: relative;\n}\n\n.rc__6x1w84 {\n  position: relative;\n  width: 100%;\n}\n\n.rc__86etrn {\n  width: 100%;\n  height: 40px;\n  padding: 0 55px 0 15px;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 20px;\n  color: var(--rc-topline-search-color);\n  border: 0;\n  border-radius: 20px;\n  background-color: var(--rc-topline-search-bgColor);\n  box-shadow: var(--rc-topline-search-boxShadow);\n}\n\n.rc__6jatxs .rc__86etrn {\n    padding: 0 95px 0 15px;\n  }\n\n.rc__86etrn::-moz-placeholder {\n    opacity: 1 !important;\n  }\n\n.rc__86etrn::placeholder {\n    opacity: 1 !important;\n  }\n\n.rc__86etrn::-moz-placeholder {\n    color: var(--rc-topline-search-placeholder-color);\n    -moz-transition: color 200ms;\n    transition: color 200ms;\n  }\n\n.rc__86etrn::placeholder {\n    color: var(--rc-topline-search-placeholder-color);\n    transition: color 200ms;\n  }\n\n@media (hover: hover) {\n    .rc__86etrn:hover::-moz-placeholder {\n      color: var(--rc-topline-search-placeholder-hover-color);\n    }\n    .rc__86etrn:hover::placeholder {\n      color: var(--rc-topline-search-placeholder-hover-color);\n    }\n  }\n\n.rc__86etrn:focus::-moz-placeholder {\n    color: var(--rc-topline-search-placeholder-active-color);\n  }\n\n.rc__86etrn:focus::placeholder {\n    color: var(--rc-topline-search-placeholder-active-color);\n  }\n\n.rc__3vg6ke {\n  padding: 0;\n  border: 0;\n  background-color: transparent;\n  box-shadow: none;\n  cursor: pointer;\n\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  top: 0;\n  font-size: 0;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  color: var(--rc-topline-search-button-color);\n}\n\n@media (hover: hover) {\n\n.rc__3vg6ke {\n    transition: color 200ms\n}\n\n    .rc__3vg6ke:hover {\n      color: var(--rc-topline-search-button-hover-color);\n    }\n  }\n\n.rc__3vg6ke:active {\n    color: var(--rc-topline-search-button-active-color);\n  }\n\n.rc__2grc97 {\n  right: 40px;\n}\n\n.rc__3hgafm {\n  right: 0;\n}\n\n.rc__6jatxs .rc__3hgafm {\n    color: var(--rc-topline-search-button-done-color);\n  }\n\n.rc__7c3w4t {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 15px;\n  background-color: var(--rc-topline-search-button-bgColor);\n}\n\n.rc__6jatxs .rc__7c3w4t {\n    background-color: var(--rc-topline-search-button-done-bgColor);\n  }\n\n@media (hover: hover) {\n\n.rc__7c3w4t {\n    transition: background-color 200ms\n}\n\n    .rc__3vg6ke:hover .rc__7c3w4t {\n      background-color: var(--rc-topline-search-button-hover-bgColor);\n    }\n\n      .rc__6jatxs .rc__3vg6ke:hover .rc__7c3w4t {\n        background-color: var(--rc-topline-search-button-done-hover-bgColor);\n      }\n  }\n\n.rc__3vg6ke:active .rc__7c3w4t {\n    background-color: var(--rc-topline-search-button-active-bgColor);\n  }\n\n.rc__6jatxs .rc__3vg6ke:active .rc__7c3w4t {\n      background-color: var(--rc-topline-search-button-done-active-bgColor);\n    }\n\n.rc__4sdj3f {\n  display: block;\n  width: 20px;\n  height: 20px;\n}\n\n.rc__4452ca {\n  margin-right: 40px;\n}\n\n.rc__455adm {\n  display: flex;\n  align-items: center;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 20px;\n  color: var(--rc-topline-color);\n  -webkit-text-decoration: none;\n  text-decoration: none;\n}\n\n@media (hover: hover) {\n\n.rc__455adm {\n    transition: color 200ms\n}\n\n    .rc__455adm:hover {\n      color: var(--rc-topline-link-hover-color);\n    }\n  }\n\n.rc__455adm:active {\n    color: var(--rc-topline-link-active-color);\n  }\n\n.rc__3r6n6x {\n  width: 40px;\n  height: 40px;\n  margin: 0 5px;\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.rc__3r6n6x.rc__27xt8r {\n      background-image: var(--rc-topline-weather-clear-night-bgImage);\n    }\n\n.rc__3r6n6x.rc__5zhdf9 {\n      background-image: var(--rc-topline-weather-clear-bgImage);\n    }\n\n.rc__3r6n6x.rc__xt7jq7 {\n      background-image: var(--rc-topline-weather-cloudy-bgImage);\n    }\n\n.rc__3r6n6x.rc__8v5q8h {\n      background-image: var(--rc-topline-weather-fog-bgImage);\n    }\n\n.rc__3r6n6x.rc__vs2d54 {\n      background-image: var(--rc-topline-weather-light-rain-night-bgImage);\n    }\n\n.rc__3r6n6x.rc__4wnk8h {\n      background-image: var(--rc-topline-weather-light-rain-bgImage);\n    }\n\n.rc__3r6n6x.rc__5pdzvf {\n      background-image: var(--rc-topline-weather-light-snow-night-bgImage);\n    }\n\n.rc__3r6n6x.rc__jkq7au {\n      background-image: var(--rc-topline-weather-light-snow-bgImage);\n    }\n\n.rc__3r6n6x.rc__8bb85a {\n      background-image: var(--rc-topline-weather-occ-light-rain-bgImage);\n    }\n\n.rc__3r6n6x.rc__34k51a {\n      background-image: var(--rc-topline-weather-occ-light-snow-bgImage);\n    }\n\n.rc__3r6n6x.rc__7raptg {\n      background-image: var(--rc-topline-weather-occ-rain-bgImage);\n    }\n\n.rc__3r6n6x.rc__5y4eyz {\n      background-image: var(--rc-topline-weather-occ-sleet-bgImage);\n    }\n\n.rc__3r6n6x.rc__23264t {\n      background-image: var(--rc-topline-weather-occ-snow-bgImage);\n    }\n\n.rc__3r6n6x.rc__5es4fh {\n      background-image: var(--rc-topline-weather-partly-cloudy-night-bgImage);\n    }\n\n.rc__3r6n6x.rc__3nswtn {\n      background-image: var(--rc-topline-weather-partly-cloudy-bgImage);\n    }\n\n.rc__3r6n6x.rc__4zhh54 {\n      background-image: var(--rc-topline-weather-rain-night-bgImage);\n    }\n\n.rc__3r6n6x.rc__5h2mrz {\n      background-image: var(--rc-topline-weather-rain-bgImage);\n    }\n\n.rc__3r6n6x.rc__52quam {\n      background-image: var(--rc-topline-weather-sleet-night-bgImage);\n    }\n\n.rc__3r6n6x.rc__7ezgu1 {\n      background-image: var(--rc-topline-weather-sleet-bgImage);\n    }\n\n.rc__3r6n6x.rc__5a16hm {\n      background-image: var(--rc-topline-weather-snow-night-bgImage);\n    }\n\n.rc__3r6n6x.rc__5szg7w {\n      background-image: var(--rc-topline-weather-snow-bgImage);\n    }\n\n.rc__3r6n6x.rc__4faj6p {\n      background-image: var(--rc-topline-weather-thunder-bgImage);\n    }\n\n@media (max-width: 1155px) {\n\n.rc__5h5w22 .rc__33zx77 {\n      display: none\n  }\n    }\n\n.rc__7uf3m5 {\n  display: flex;\n  align-items: center;\n  -moz-column-gap: 20px;\n       column-gap: 20px;\n  margin-right: 40px;\n}\n\n.rc__8b6d8y {\n  display: flex;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 20px;\n  -webkit-text-decoration: none;\n  text-decoration: none;\n}\n\n.rc__5x7r7w {\n  display: inline-flex;\n  color: var(--rc-topline-exchangeRates-currecy-color);\n  margin-right: 5px;\n}\n\n.rc__5wh9q9 {\n  color: var(--rc-topline-color);\n}\n\n@media (hover: hover) {\n\n.rc__5x7r7w,\n.rc__5wh9q9 {\n    transition: color 200ms\n}\n\n    .rc__8b6d8y:hover .rc__5x7r7w, .rc__8b6d8y:hover .rc__5wh9q9 {\n      color: var(--rc-topline-link-hover-color);\n    }\n  }\n\n.rc__8b6d8y:active .rc__5x7r7w, .rc__8b6d8y:active .rc__5wh9q9 {\n    color: var(--rc-topline-link-active-color);\n  }\n\n.rc__7f3k5k {\n  display: inline-flex;\n  width: 20px;\n  height: 20px;\n  color: var(--rc-topline-exchangeRates-up-color);\n}\n\n.rc__7f3k5k.rc__4h3kud {\n    color: var(--rc-topline-exchangeRates-down-color);\n    transform: rotate(180deg);\n  }\n\n.rc__4wrhdz {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  margin-right: 40px;\n}\n\n.rc__56h59c {\n  display: flex;\n  gap: 10px;\n}\n\n  .rc__56h59c.rc__ekn5np {\n    flex-grow: 1;\n    justify-content: flex-end;\n  }\n\n.rc__29x3bb {\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 40px;\n  -webkit-text-decoration: none;\n  text-decoration: none;\n}\n\n.rc__4axx6f {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  z-index: 0;\n}\n\n.rc__8zuf4g .rc__4axx6f::after {\n    content: \"\";\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    right: 2.5px;\n    bottom: 5px;\n    border-radius: 5px;\n    background: var(--rc-topline-ui-unread-bg);\n    z-index: 1;\n  }\n\n.rc__4axx6f::before {\n  content: \"\";\n  position: absolute;\n  width: 40px;\n  height: 40px;\n  top: 0;\n  left: 0;\n  border-radius: 20px;\n  background-color: var(--rc-topline-area-bgColor);\n  transform: scale(0.1);\n  z-index: -1;\n}\n\n@media (hover: hover) {\n\n.rc__4axx6f::before {\n    transition: background-color 100ms, transform 100ms\n}\n\n    .rc__29x3bb:hover .rc__4axx6f::before {\n      background-color: var(--rc-topline-area-hover-bgColor);\n      transform: scale(1);\n    }\n  }\n\n.rc__29x3bb:active .rc__4axx6f::before {\n    background-color: var(--rc-topline-area-active-bgColor);\n    transform: scale(1);\n  }\n\n.rc__2pq3vx {\n  display: block;\n  width: 25px;\n  height: 25px;\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.rc__2bcj7b .rc__2pq3vx {\n    background-image: var(--rc-topline-ui-icon-mail-bgImage);\n  }\n\n.rc__72616a {\n  margin-left: 5px;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 20px;\n  color: var(--rc-topline-color);\n}\n\n@media (hover: hover) {\n\n.rc__72616a {\n    transition: color 200ms\n}\n\n    .rc__29x3bb:hover .rc__72616a {\n      color: var(--rc-topline-link-hover-color);\n    }\n  }\n\n.rc__29x3bb:active .rc__72616a {\n    color: var(--rc-topline-link-active-color);\n  }\n\n@media (max-width: 1210px) {\n\n.rc__2bcj7b.rc__8dd4rx .rc__72616a {\n      display: none\n  }\n    }\n\n.rc__5xfz3h {\n  flex-grow: 1;\n  margin-right: 40px;\n}\n\n:root {\n  --rc-topline-height: 70px;\n  --rc-topline-header-height: 60px;\n\n  --rc-topline-color: #343b4c;\n  --rc-topline-link-color: #315efb;\n  --rc-topline-link-hover-color: #2c54e2;\n  --rc-topline-link-active-color: #274bc8;\n  --rc-topline-email-color: #777e98;\n  --rc-topline-email-copied-color: rgba(119,126,152, 0);\n\n  --rc-topline-bgColor: #ffffff;\n  --rc-topline-extra-bgColor: #eff5ff;\n  --rc-topline-avatar-bgColor: #eff5ff;\n  --rc-topline-boxShadow: 0 5px 30px -10px rgba(49,94,251, 0.3);\n\n  --rc-topline-search-color: #343b4c;\n  --rc-topline-search-bgColor: #ffffff;\n  --rc-topline-search-boxShadow: 0 10px 20px -5px rgba(49,94,251, 0.15);\n  --rc-topline-search-placeholder-color: #315efb;\n  --rc-topline-search-placeholder-hover-color: rgba(49,94,251, 0.7);\n  --rc-topline-search-placeholder-active-color: #afb6c9;\n  --rc-topline-search-colorEllipse-bg: linear-gradient(90deg, #315EFB 20%, #00E8FF 60%, #00FFB3 90%, #00E8FF 100%);\n  --rc-topline-search-blueEllipse-bg: rgba(49,94,251, 0.15);\n\n  --rc-topline-search-button-color: #315efb;\n  --rc-topline-search-button-bgColor: #eff5ff;\n  --rc-topline-search-button-hover-color: #2c54e2;\n  --rc-topline-search-button-hover-bgColor: #e0ebff;\n  --rc-topline-search-button-active-color: #274bc8;\n  --rc-topline-search-button-active-bgColor: #d1e2ff;\n\n  --rc-topline-search-button-done-color: #ffffff;\n  --rc-topline-search-button-done-bgColor: #315efb;\n  --rc-topline-search-button-done-hover-bgColor: #2c54e2;\n  --rc-topline-search-button-done-active-bgColor: #274bc8;\n\n  --rc-topline-area-bgColor: transparent;\n  --rc-topline-area-hover-bgColor: #eff5ff;\n  --rc-topline-area-active-bgColor: #e0ebff;\n\n  --rc-topline-suggest-bgColor: #ffffff;\n  --rc-topline-suggest-boxShadow: 0 10px 30px -5px rgba(49,94,251, 0.30);\n  --rc-topline-suddgest-separator-border: 1px solid #e0ebff;\n\n  --rc-topline-ui-unread-bg: radial-gradient(66.13% 81.39% at 65% 20%, #ff807a 0%, #ff3c32 100%);\n\n  --rc-topline-exchangeRates-currecy-color: #8d96b2;\n  --rc-topline-exchangeRates-up-color: #28bc00;\n  --rc-topline-exchangeRates-down-color: #ff564e;\n\n  --rc-topline-spasibo-link-color: #21ba72;\n  --rc-topline-spasibo-link-hover-color: #1ea767;\n  --rc-topline-spasibo-link-active-color: #1a955b;\n    --rc-topline-product-advertising-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/advertising.svg?1\")\n;\n    --rc-topline-product-ai-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/ai.svg?1\")\n;\n    --rc-topline-product-auto-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/auto.svg?1\")\n;\n    --rc-topline-product-dating-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/dating.svg?1\")\n;\n    --rc-topline-product-doctor-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/doctor.svg?1\")\n;\n    --rc-topline-product-dom-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/dom.svg?1\")\n;\n    --rc-topline-product-family-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/family.svg?1\")\n;\n    --rc-topline-product-finance-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/finance.svg?1\")\n;\n    --rc-topline-product-help-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/help.svg?1\")\n;\n    --rc-topline-product-home-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/home.svg?1\")\n;\n    --rc-topline-product-horoscopes-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/horoscopes.svg?1\")\n;\n    --rc-topline-product-id-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/id.svg?1\")\n;\n    --rc-topline-product-images-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/images.svg?1\")\n;\n    --rc-topline-product-kino-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/kino.svg?1\")\n;\n    --rc-topline-product-life-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/life.svg?1\")\n;\n    --rc-topline-product-likes-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/likes.svg?1\")\n;\n    --rc-topline-product-mail-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/mail.svg?1\")\n;\n    --rc-topline-product-more-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/more.svg?1\")\n;\n    --rc-topline-product-news-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/news.svg?1\")\n;\n    --rc-topline-product-pro-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/pro.svg?1\")\n;\n    --rc-topline-product-sci-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/sci.svg?1\")\n;\n    --rc-topline-product-search-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/search.svg?1\")\n;\n    --rc-topline-product-sport-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/sport.svg?1\")\n;\n    --rc-topline-product-starlife-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/starlife.svg?1\")\n;\n    --rc-topline-product-terms-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/terms.svg?1\")\n;\n    --rc-topline-product-top100-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/top100.svg?1\")\n;\n    --rc-topline-product-travel-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/travel.svg?1\")\n;\n    --rc-topline-product-tv-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/tv.svg?1\")\n;\n    --rc-topline-product-weather-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/weather.svg?1\")\n;\n    --rc-topline-product-weekend-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/weekend.svg?1\")\n;\n    --rc-topline-product-woman-bgImage: url(\"https://static.rambler.ru/assets/v2/product/140/woman.svg?1\")\n;\n    --rc-topline-logo-rambler-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/rambler.svg?1\")\n;\n    --rc-topline-logo-rambler-small-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/rambler-small.svg?1\")\n;\n    --rc-topline-logo-ai-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/ai.svg?1\")\n;\n    --rc-topline-logo-auto-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/auto.svg?1\")\n;\n    --rc-topline-logo-doctor-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/doctor.svg?1\")\n;\n    --rc-topline-logo-dom-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/dom.svg?1\")\n;\n    --rc-topline-logo-family-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/family.svg?1\")\n;\n    --rc-topline-logo-finance-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/finance.svg?1\")\n;\n    --rc-topline-logo-help-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/help.svg?1\")\n;\n    --rc-topline-logo-life-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/life.svg?1\")\n;\n    --rc-topline-logo-news-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/news.svg?1\")\n;\n    --rc-topline-logo-pro-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/pro.svg?1\")\n;\n    --rc-topline-logo-sci-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/sci.svg?1\")\n;\n    --rc-topline-logo-soft-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/soft.svg?1\")\n;\n    --rc-topline-logo-sport-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/sport.svg?1\")\n;\n    --rc-topline-logo-weekend-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/weekend.svg?1\")\n;\n    --rc-topline-logo-horoscopes-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/horoscopes.svg?1\")\n;\n    --rc-topline-logo-tv-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/tv.svg?1\")\n;\n    --rc-topline-logo-weather-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/weather.svg?1\")\n;\n    --rc-topline-logo-kino-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/kino.svg?1\")\n;\n    --rc-topline-logo-travel-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/travel.svg?1\")\n;\n    --rc-topline-logo-woman-bgImage: url(\"https://static.rambler.ru/assets/v2/logotypes/woman.svg?1\")\n;\n    --rc-topline-ui-icon-calendar-bgImage: url(\"https://static.rambler.ru/assets/v2/product/16/calendar.svg\")\n;\n    --rc-topline-ui-icon-comments-bgImage: url(\"https://static.rambler.ru/assets/v2/product/16/comments.svg\")\n;\n    --rc-topline-ui-icon-mail-bgImage: url(\"https://static.rambler.ru/assets/v2/product/16/mail.svg\")\n;\n    --rc-topline-weather-clear-night-bgImage: url(\"https://static.rambler.ru/assets/weather/30/clear-night.svg\")\n;\n    --rc-topline-weather-clear-bgImage: url(\"https://static.rambler.ru/assets/weather/30/clear.svg\")\n;\n    --rc-topline-weather-cloudy-bgImage: url(\"https://static.rambler.ru/assets/weather/30/cloudy.svg\")\n;\n    --rc-topline-weather-fog-bgImage: url(\"https://static.rambler.ru/assets/weather/30/fog.svg\")\n;\n    --rc-topline-weather-light-rain-night-bgImage: url(\"https://static.rambler.ru/assets/weather/30/light-rain-night.svg\")\n;\n    --rc-topline-weather-light-rain-bgImage: url(\"https://static.rambler.ru/assets/weather/30/light-rain.svg\")\n;\n    --rc-topline-weather-light-snow-night-bgImage: url(\"https://static.rambler.ru/assets/weather/30/light-snow-night.svg\")\n;\n    --rc-topline-weather-light-snow-bgImage: url(\"https://static.rambler.ru/assets/weather/30/light-snow.svg\")\n;\n    --rc-topline-weather-occ-light-rain-bgImage: url(\"https://static.rambler.ru/assets/weather/30/occ-light-rain.svg\")\n;\n    --rc-topline-weather-occ-light-snow-bgImage: url(\"https://static.rambler.ru/assets/weather/30/occ-light-snow.svg\")\n;\n    --rc-topline-weather-occ-rain-bgImage: url(\"https://static.rambler.ru/assets/weather/30/occ-rain.svg\")\n;\n    --rc-topline-weather-occ-sleet-bgImage: url(\"https://static.rambler.ru/assets/weather/30/occ-sleet.svg\")\n;\n    --rc-topline-weather-occ-snow-bgImage: url(\"https://static.rambler.ru/assets/weather/30/occ-snow.svg\")\n;\n    --rc-topline-weather-partly-cloudy-night-bgImage: url(\"https://static.rambler.ru/assets/weather/30/partly-cloudy-night.svg\")\n;\n    --rc-topline-weather-partly-cloudy-bgImage: url(\"https://static.rambler.ru/assets/weather/30/partly-cloudy.svg\")\n;\n    --rc-topline-weather-rain-night-bgImage: url(\"https://static.rambler.ru/assets/weather/30/rain-night.svg\")\n;\n    --rc-topline-weather-rain-bgImage: url(\"https://static.rambler.ru/assets/weather/30/rain.svg\")\n;\n    --rc-topline-weather-sleet-night-bgImage: url(\"https://static.rambler.ru/assets/weather/30/sleet-night.svg\")\n;\n    --rc-topline-weather-sleet-bgImage: url(\"https://static.rambler.ru/assets/weather/30/sleet.svg\")\n;\n    --rc-topline-weather-snow-night-bgImage: url(\"https://static.rambler.ru/assets/weather/30/snow-night.svg\")\n;\n    --rc-topline-weather-snow-bgImage: url(\"https://static.rambler.ru/assets/weather/30/snow.svg\")\n;\n    --rc-topline-weather-thunder-bgImage: url(\"https://static.rambler.ru/assets/weather/30/thunder.svg\")\n\n}\n\n.rc__3asvyx {\n  position: relative;\n  min-width: 1010px;\n  background-color: var(--rc-topline-bgColor);\n  z-index: 15;\n}\n\n.rc__215akj,\n.rc__2bj87v {\n  position: absolute;\n  overflow: hidden;\n  left: 0;\n  right: 0;\n  opacity: 0;\n  transition: opacity 400ms;\n  pointer-events: none;\n}\n\n.rc__215akj.rc__8j93cj, .rc__2bj87v.rc__8j93cj {\n    opacity: 0.8;\n  }\n\n.rc__215akj .rc__5fwmzw,\n  .rc__215akj .rc__48e6jv,\n  .rc__2bj87v .rc__5fwmzw,\n  .rc__2bj87v .rc__48e6jv {\n    position: absolute;\n    height: 200px;\n    border-radius: 100%;\n    background: var(--rc-topline-search-colorEllipse-bg);\n    filter: blur(50px);\n  }\n\n.rc__215akj {\n  top: 0;\n  bottom: 0;\n}\n\n.rc__215akj .rc__5fwmzw {\n    bottom: -199px;\n  }\n\n.rc__2bj87v {\n  height: 150px;\n  top: 100%;\n}\n\n.rc__2bj87v .rc__5fwmzw {\n    top: -199px;\n  }\n\n.rc__6ajzxr {\n  position: relative;\n  height: var(--rc-topline-height);\n  z-index: 2;\n}\n\n.rc__6ajzxr .rc__8wcknd {\n    height: var(--rc-topline-height);\n  }\n\n.rc__3yjsqa {\n  width: 100%;\n  min-width: 1010px;\n}\n\n.rc__3yjsqa.rc__2nv4nm {\n    position: fixed;\n    top: -70px;\n    left: 0;\n    transform: translate(0, 0);\n    transition: transform 200ms;\n    z-index: 15;\n  }\n\n.rc__3yjsqa.rc__2nv4nm.rc__25r65k {\n      box-shadow: var(--rc-topline-boxShadow);\n    }\n\n.rc__3yjsqa.rc__7y64ha {\n    background-color: var(--rc-topline-bgColor);\n    transform: translate(0, 70px);\n  }\n\n.rc__6mqu3t {\n  position: relative;\n  z-index: 1;\n}\n\n.rc__6mqu3t .rc__8wcknd {\n    height: var(--rc-topline-header-height);\n  }\n\n.rc__8wcknd {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n@media (min-width: 1300px) {\n\n.rc__51k77w {\n    width: 1260px;\n    padding-left: 0;\n    padding-right: 0\n}\n  }\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
